/**
=========================================================
* Soft UI Dashboard React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import axios from 'axios';

import { Helmet } from "react-helmet";

// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/FullDashboardLayout";
import DashboardNavbarNotLooged from "examples/Navbars/DashboardNavbarNotLooged";

import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import SoftInput from "components/SoftInput";

// @mui material components
import Card from "@mui/material/Card";


import Grid from "@mui/material/Grid";

import Parser from 'html-react-parser';
import SoftButton from "components/SoftButton";
//import { AutoComplete } from 'primereact/autocomplete';
import Autocomplete from '@mui/material/Autocomplete';


// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import team2 from "assets/images/team-2.jpg";

//import Modal from 'react-bootstrap/Modal';

// Data
//import membersTableData from "layouts/groups/data/membersTableData";

import SoftAvatar from "components/SoftAvatar";

// Images
import 'auction.css';
import TextField from '@mui/material/TextField';

import React, { useState, useEffect } from "react";
import { Wheel } from "react-custom-roulette";
import Modal from 'react-modal';
import FormSelect from 'react-bootstrap/FormSelect';
import { FaBackward } from "react-icons/fa";
import { FaPenSquare } from "react-icons/fa";
import { FaListUl, FaTimesCircle } from "react-icons/fa";
import { styled } from "@mui/material/styles";
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import team_player_2 from "assets/images/team-2.jpg";
import loader_img from "assets/images/loader.svg";
import ReactImageZoom from 'react-image-zoom';
import livelogo from "assets/images/livecricketkerala.png";
import {  Link } from "react-router-dom";

import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const SpinnerWrapStyle = styled('div')`
 display: flex;
 align-items: center;
 justify-content: center;
 flex-direction: column;
`;

const Spinner = () => (
  <img src={loader_img} class="zoom2" height="30"/>
)


const AuctionModalWrapper = styled('div')({
  position: 'relative',

  overflow:'auto',
 '& .player-dp': {
  margin : '0 auto',
  width: '300px',
  maxWidth: '95%',
  position: 'relative',
  'img': {
    width: '100%',
    maxWidth: '100%',
    borderRadius: '10px'
  },
  ' & .player-number' : {
    fontSize: '18px',
    position: 'absolute',
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    lineHeight:'30px',
    color: '#fff',
    top: '0',
    right: '0',
    textAlign :'center',
    backgroundColor: 'coral'
  }
},
'& .player-name':{
  textAlign :'center',
  textTransform: 'uppercase',
  fontSize: '40px'
},
'& .close-btn' : {
  backgroundColor: 'transparent',
  border: 'none',
  outline: 'none',
  fontSize: '30px',
  position: 'absolute',
  right: '-5px',
  top: '-10px',
  cursor: 'pointer',
},
'& .custom-select-wrap' : {
  border: '1px solid #d2d6da',
  cursor: 'pointer',
  position: 'relative',
  padding: '0 10px 3px',
  borderRadius: '8px',
  '&:after': {
    content: '""',
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderWidth: '6px 5px 0 5px',
    borderColor: '#000000 transparent transparent transparent',
    position: 'absolute',
    right: '10px',
    top: '15px'
    
  },
  'select': {
    cursor: 'pointer',
    padding: '5px',
    border: 0,
    outline: 0,
    backgroundColor: 'transparent',
    '-moz-appearance': 'none',
    '-webkit-appearance': 'none',
  },
  'select:focus': {
    outline: 'thin dotted',
  outline: '5px auto -webkit-focus-ring-color',
  'outline-offset': '-2px'
  }
}

});

const customStyles = {
  content: {
    left: '2%',
    top : '0',
    bottom : '0',
    width: '96%',
  },
  overlay: { zIndex: 1000 }
};
const panelStyle = {
  zIndex: 100000 // Set the desired z-index value
};


const customStyles1 = {
  content: {
    top: '40%',
    left: '50%',
    width: '75%',
    right: 'auto',
    bottom: 'auto',
    overflow : 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
  overlay: { zIndex: 1000 }
};


const data = [
  { option: "0", style: { backgroundColor: "#c2db62", textColor: "white" } },
  { option: "1", style: { backgroundColor: "#5fbd5a", textColor: "white" } },
  { option: "3", style: { backgroundColor: "#c2db62", textColor: "white" } },
  { option: "4", style: { backgroundColor: "#5fbd5a", textColor: "white" } },
  { option: "5", style: { backgroundColor: "#c2db62", textColor: "white" } },
  { option: "6", style: { backgroundColor: "#5fbd5a", textColor: "white" } },
  { option: "7", style: { backgroundColor: "#c2db62", textColor: "white" } },
  { option: "8", style: { backgroundColor: "#5fbd5a", textColor: "white" } }

];



function SoldPlayer({ user_id, player_name, team_name, team_id, sold_amount, sl_no, captain_flag, noGutter }) {
  return (
    <SoftBox
      component="li"
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      bgColor="grey-100"
      borderRadius="lg"
      p={3}
      mb={noGutter ? 0 : 1}
      mt={2}
    >
      <SoftBox width="100%" display="flex" flexDirection="column">

        <SoftBox mb={1} lineHeight={0}>
          <SoftTypography variant="caption" color="text">

            <SoftTypography variant="caption" textTransform="capitalize">
              {player_name} ({team_name})
              {
                // alert(captain_flag)
                (() => {
                  if (captain_flag == 0) {
                    return (<FaPenSquare onClick={() => window.helloComponent.onEditSellModal(sl_no, player_name, team_id, sold_amount, user_id)}></FaPenSquare>)
                  } else {
                    return (<span>&nbsp;(c)</span>)
                  }
                })()
              }

            </SoftTypography>

          </SoftTypography>
        </SoftBox>



      </SoftBox>
    </SoftBox>
  );
}

function UnsoldPlayer({ user_id, player_name, sl_no, profile_pic, cric_heroes_profile_link, noGutter, viewMode = 'normal', onImagePreview }) {
  if (viewMode === 'big_tile') {
    return (
      <SoftBox
        mb={noGutter ? 0 : 1}
        className="player-list-item unsold player-tile"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1.5,
          p: 2,
          border: '1px solid rgba(0,0,0,0.1)',
          borderRadius: 2,
          cursor: 'pointer',
          backgroundColor: 'white',
          position: 'relative',
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.05)',
            boxShadow: 2
          }
        }}
      >
        <SoftAvatar
          src={profile_pic || team_player_2}
          alt={player_name}
          variant="rounded"
          size="lg"
          sx={{ 
            width: 100, 
            height: 100,
            cursor: 'pointer',
            '&:hover': {
              opacity: 0.8,
              transform: 'scale(1.05)',
              transition: 'all 0.2s'
            }
          }}
          onClick={(e) => {
            e.stopPropagation();
            if (onImagePreview) {
              onImagePreview(profile_pic || team_player_2);
            }
          }}
        />
        <SoftBox sx={{ textAlign: 'center', width: '100%' }}>
          <SoftTypography variant="h6" color="text" fontWeight="medium">
            {player_name}
          </SoftTypography>
          <SoftTypography variant="caption" color="text">
            SL No: {sl_no}
          </SoftTypography>
        </SoftBox>
        <SoftBox sx={{ position: 'absolute', top: 8, right: 8 }}>
          <FaBackward title="Move to Pending" id="movependingbtn" onClick={() => window.helloComponent.onClickReverseUnSold(user_id)} />
          <img src={loader_img} id="loadergif_unsold_pending" style={{display:'none'}} class="zoom2" height="30"/>
        </SoftBox>
      </SoftBox>
    );
  }
  
  return (
    <SoftBox
      mb={noGutter ? 0 : 1}
      className="player-list-item unsold"
    >
      <SoftTypography variant="caption" color="text">
        <span className="player-name">
          {sl_no}. {player_name}
        </span>
        &nbsp;
        <FaBackward title="Move to Pending" id="movependingbtn" onClick={() => window.helloComponent.onClickReverseUnSold(user_id)} />
        <img src={loader_img} id="loadergif_unsold_pending" style={{display:'none'}} class="zoom2" height="30"/>
      </SoftTypography>
    </SoftBox>
  );
}
function PendingPlayer({ user_id, player_name, sl_no,icon_text, profile_pic, cric_heroes_profile_link, noGutter ,onClickPlayerProfileToSell, viewMode = 'normal', onImagePreview}) {
  if (viewMode === 'big_tile') {
    return (
      <SoftBox
        mb={noGutter ? 0 : 1}
        className="player-list-item pending player-tile"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 1.5,
          p: 2,
          border: '1px solid rgba(0,0,0,0.1)',
          borderRadius: 2,
          cursor: 'pointer',
          backgroundColor: 'white',
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.05)',
            boxShadow: 2
          }
        }}
        onDoubleClick={() => onClickPlayerProfileToSell(sl_no)}
      >
        <SoftAvatar
          src={profile_pic || team_player_2}
          alt={player_name}
          variant="rounded"
          size="lg"
          sx={{ 
            width: 100, 
            height: 100,
            cursor: 'pointer',
            '&:hover': {
              opacity: 0.8,
              transform: 'scale(1.05)',
              transition: 'all 0.2s'
            }
          }}
          onClick={(e) => {
            e.stopPropagation();
            if (onImagePreview) {
              onImagePreview(profile_pic || team_player_2);
            }
          }}
        />
        <SoftBox sx={{ textAlign: 'center', width: '100%' }}>
          <SoftTypography variant="h6" color="info" fontWeight="medium">
            {player_name}
          </SoftTypography>
          <SoftTypography variant="caption" color="text">
            SL No: {sl_no}
          </SoftTypography>
          {
            (() => {
              if (icon_text !==  '' &&  icon_text != null) {
                return (<span className="chip chip-danger">({icon_text})****</span>)
              }
            })()
          }
        </SoftBox>
      </SoftBox>
    );
  }
  
  return (
    <SoftBox
      mb={noGutter ? 0 : 1}
      className="player-list-item pending"
    >
      <SoftTypography
        variant="caption"
        color="info"
        fontWeight="medium"
        textTransform="capitalize"
        onDoubleClick={() => onClickPlayerProfileToSell(sl_no)}
      >
        <span className="player-name">{sl_no}. {player_name}</span>
        {
          (() => {
            if (icon_text !==  '' &&  icon_text != null) {
              return (<span className="chip chip-danger">({icon_text})****</span>)
            }
          })()
        }
      </SoftTypography>
    </SoftBox>
  );
}

function Team({ team_name, team_logo, current_wallet_balance,team_max_playes_count, current_players_count, players,max_bid_for_a_player, noGutter }) {
  var line_bg = "";
  if(current_players_count == team_max_playes_count)
  {
    line_bg = "info";
  }

  const valuep =`${current_players_count}/${team_max_playes_count}`;
  const vpercentage = ((current_players_count / team_max_playes_count) * 100).toFixed(2); // Keeps two decimal places

  // Stable per-team accent color based on team name
  const accentPalette = ["#6366f1", "#10b981", "#f59e0b", "#ef4444", "#06b6d4", "#8b5cf6", "#14b8a6", "#f97316"]; 
  const nameHash = (name) => {
    if(!name) return 0;
    let h = 0; for (let i = 0; i < name.length; i++) { h = ((h << 5) - h) + name.charCodeAt(i); h |= 0; }
    return Math.abs(h);
  };
  const teamAccent = accentPalette[nameHash(team_name) % accentPalette.length];


  return (

    <SoftBox item  mb={4} xs={4} md={4} >
       
          

      <table width="100%" className="team-summary-modern" style={{ borderLeft: `6px solid ${teamAccent}` }}>
                    <tbody>
                      <tr>
<td width="10%"><SoftAvatar
            src={team_logo ? (team_logo) : (team2)}
            alt="profile-image"
            variant="rounded"
            size="sm"
            shadow="sm"
          /></td>

          <td width="20%"><SoftTypography variant="button" fontWeight="medium" textTransform="capitalize">
            <b>{team_name}</b>
          </SoftTypography>
          </td>

          <td width="20%" fontSize="8px" size="sm">
          <SoftTypography variant="caption" size="sm" className="team-meta-label">
          Wallet Balance:
          </SoftTypography>
          </td>
        <td width="10%">
        <SoftTypography variant="caption" fontSize="18px"  className="team-meta-value">
              <b>{current_wallet_balance}</b>
            </SoftTypography>
        </td>

        <td width="20%" fontSize="8px" size="sm">
        <SoftTypography variant="caption" size="sm" className="team-meta-label">
          Maximum bid for a player:</SoftTypography>
          </td>
        <td width="10%">
        <SoftTypography variant="caption" fontSize="18px" className="team-meta-value">
              <b>{max_bid_for_a_player}</b>
            </SoftTypography>
        </td>

        <td width="20%">
        <SoftTypography variant="caption" size="sm" className="team-meta-label">
        Current count:
        </SoftTypography>
          </td>
        <td width="10%">
        <SoftTypography variant="caption" fontWeight="medium">

        <div style={{ width: 40, height: 40 }}>
                        <CircularProgressbar value={vpercentage} text={`${valuep}`} />
                      </div>

            </SoftTypography>
        </td>

      </tr></tbody>
      </table>




{
      (() => {
      const listitems = players;
      //console.log(listitems);
      //console.log("populating")
      if (typeof(listitems) != "undefined")
      {
      //console.log(listitems)
  const rows = [];
  for (let i = 0; i < listitems.length; i++) 
  {
    let captain_flag_name = "";
    //team_name,  team_logo, current_wallet_balance, current_players_count, players
      if(listitems[i].captain_flag=='1')
      {
        captain_flag_name = " (C)";
      }
      rows.push(
        <SoftTypography size="sm" className="team-player-item">
          <span className="num">{i+1}</span>
          <span className="name">{listitems[i].full_name}{captain_flag_name}</span>
          <span className="meta">&nbsp;[{listitems[i].sl_no}]&nbsp;({listitems[i].auction_sold_amount})</span>
          {
            (() => {
              if (listitems[i].captain_flag == 0) {
                return (<FaPenSquare onClick={() => window.helloComponent.onEditSellModal(listitems[i].sl_no, listitems[i].full_name, listitems[i].match_team_fk, listitems[i].auction_sold_amount, listitems[i].user_fk)}></FaPenSquare>)
              } else {
                return (<span>&nbsp;(c)</span>)
              }
            })()
          }
          {
            (() => {
              if (listitems[i].last_sold_status_flag == 1) {
                return (<span className="recent-flag">***</span>)
              }
            })()
          }
        </SoftTypography>
      );
  }
  return rows;
}

})()

}


    </SoftBox>
  );
}

function PopTeam({ team_name, team_logo, team_max_playes_count,current_wallet_balance, current_players_count, players,max_bid_for_a_player, noGutter }) {
  var line_bg = "";
  if(current_players_count == team_max_playes_count)
  {
    line_bg = "info";
  }
  return (
    <Grid xs={12} md={12}>
       
          <SoftAvatar
            src={team_logo ? (team_logo) : (team2)}
            alt="profile-image"
            variant="rounded"
            size="sm"
            shadow="sm"
          />

          <SoftTypography variant="button" fontWeight="medium" textTransform="capitalize">
            {team_name}
          </SoftTypography>

         

        <SoftBox mb={1} lineHeight={0}>
          <SoftTypography variant="caption" color="text">
            Wallet Balance:&nbsp;&nbsp;&nbsp;
            <SoftTypography variant="caption" fontWeight="medium">
              {current_wallet_balance}
            </SoftTypography>
          </SoftTypography>
        </SoftBox>
        <SoftBox mb={1} lineHeight={0}>
        <SoftTypography variant="caption" color="text">
          Maximum bid for a player:&nbsp;&nbsp;&nbsp;
          <SoftTypography variant="caption" fontWeight="medium">
            {max_bid_for_a_player}
          </SoftTypography>
        </SoftTypography>
        </SoftBox>

        <SoftBox mb={1} lineHeight={0} bgColor={line_bg}>
        <SoftTypography variant="caption" color="text">
          Current Count:&nbsp;&nbsp;&nbsp;
          <SoftTypography variant="caption" fontWeight="medium">
            {current_players_count}
          </SoftTypography>
          
           </SoftTypography>
           </SoftBox>





    </Grid>
  );
}



class AuctionSpinner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {value:'',items:['Apple', 'Banana', 'Cherry', 'Date', 'Elderberry'],org_items:['Apple', 'Banana', 'Cherry', 'Date', 'Elderberry'], x: false, sx: false, main_auction_details: { group_name: 'Group Name' }, spin_data: data ,team_max_playes_count: -1, auction_display_flag: 0, playersListViewMode: 'normal', previewImageUrl: null, previewImageOpen: false};
    window.helloComponent = this;

    this.autocompleteRef = React.createRef();
    this.allItems = ['Apple', 'Banana', 'Cherry', 'Date', 'Elderberry'];
    setInterval(this.getCurrentBid, 6000);
    //    this.setState({x: false,sx: false});

  }
  handleSelect = (value) => {
    // Set the input value using the reference
    this.autocompleteRef.current.setState({ value });
  };


  onClickPlayerProfileToSell  = (sl_no) => {
    
    this.setState({ enter_manually: 1 });
    setTimeout(() => {
      //document.getElementById('e_enter_manually').focus();
      const inputField = document.getElementById('e_enter_manually');
      if (inputField) {
        inputField.value = sl_no; // Set sl_no as the value
  
        // Trigger input event to simulate a change in the field
        const inputEvent = new Event('input', { bubbles: true });
        inputField.dispatchEvent(inputEvent);
  
        // Focus the input field
        inputField.focus();
  
        // Optionally, if you need to simulate form submission:
        const enterEvent = new KeyboardEvent('keypress', {
          key: 'Enter',
          code: 'Enter',
          keyCode: 13,
          charCode: 13,
          bubbles: true,
        });
  
        inputField.dispatchEvent(enterEvent); // Dispatch the Enter event
      }

    }, 700);


  };


  handleMenuVisibilityChange = (isOpen) => {
    if (isOpen) {
      // You can fetch suggestions here based on the current input value
      const inputValue = this.autocompleteRef.current.state.value;
      const filteredItems = this.allItems.filter(
        (item) => item.toLowerCase().includes(inputValue.toLowerCase())
      );
      // Set the list of items using the reference
      this.autocompleteRef.current.setState({ items: filteredItems });
    }
  };
  handleChange = (event, newValue) => {
    document.getElementById('a_match_team_id').focus();
  }

  handleHighlightChange = (event, newValue) => {
    console.log(newValue)
    this.updateCurrentBid(newValue);
  }


  search = (event) => {
    console.log(event.query.toLowerCase() )
    //this.setState([...Array(10).keys()].map(item => event.query + '-' + this.state.item));
    setTimeout(() => {

    let _filteredCountries =this.state.org_items;
    //console.log(_filteredCountries )

            if (!event.query.trim().length) {
                _filteredCountries = this.state.org_items;
            }
            else {
                _filteredCountries = _filteredCountries.filter((country) => {

                  country = ''+country;
                    //return country.toLowerCase().startsWith(event.query.toLowerCase());
                    return country.toLowerCase().includes(event.query.toLowerCase());
                });
            }

            this.setState({items:_filteredCountries
            });
          }, 250);
            //setFilteredCountries(_filteredCountries);


    console.log(this.state.items);

}



  onEditSellModal = (sl_no, player_name, team_id, sold_amount, user_id, e) => {
    this.setState({
      showEditSell: !this.state.showEditSell,
      e_selected_sl: sl_no,
      e_selected_player: player_name,
      e_team_id: team_id,
      e_selected_user_fk:user_id,
      e_sold_amount: sold_amount
    });

    setTimeout(
      () => document.getElementById('e_a_match_team_id').value = team_id,
      700
    );
    setTimeout(
      () => document.getElementById('e_a_sold_amount').value = sold_amount,
      700
    );

    //



  };

  //const [x, sx] = React.useState(false);

  stopSpin = e => {
    console.log("stoppppppppp", e);
    //sx(false);
    //alert(this.state.spin_data[this.state.prizeNo].player_name)

    //this.setState({optSmModal:false})
//alert(this.state.prizeNo+","+this.state.spin_data[this.state.prizeNo].option)
    this.setState({
      x: false, prizeNo: 1, showSell: !this.state.showSell,
      selected_sl: this.state.spin_data[this.state.prizeNo].option,
      //selected_new_player_id: this.state.spin_data[this.state.player_id].option,
      selected_new_player_id: this.state.spin_data[this.state.prizeNo].player_id,
      selected_player: this.state.spin_data[this.state.prizeNo].player_name,
      selected_player_pic : this.state.spin_data[this.state.prizeNo].player_pic,
      selected_cric_img : this.state.spin_data[this.state.prizeNo].cric_heroes_profile_img,
      cric_heroes_profile_link : this.state.spin_data[this.state.prizeNo].cric_heroes_profile_link,
      selected_cric_heroes_last_updated_on: this.state.spin_data[this.state.prizeNo].cric_heroes_last_updated_on,
      icon_text  : this.state.spin_data[this.state.prizeNo].icon_text,
      selected_cric_batting_style : this.state.spin_data[this.state.prizeNo].cric_batting_style,
      selected_cric_bowling_style : this.state.spin_data[this.state.prizeNo].cric_bowling_style,
      selected_cric_matches : this.state.spin_data[this.state.prizeNo].cric_matches,
      selected_cric_runs : this.state.spin_data[this.state.prizeNo].cric_runs,
      selected_cric_wickets : this.state.spin_data[this.state.prizeNo].cric_wickets,
      selected_cric_tags : this.state.spin_data[this.state.prizeNo].cric_tags,
      selected_role : this.state.spin_data[this.state.prizeNo].role,
      selected_keeping : this.state.spin_data[this.state.prizeNo].keeping_flag,
      selected_district_name : this.state.spin_data[this.state.prizeNo].district_name,
      selected_previous_team_details : this.state.spin_data[this.state.prizeNo].previous_team_details,
    });
   // console.log(this.state.spin_data[this.state.prizeNo])
    
    this.showSellModal(this.state.spin_data[this.state.prizeNo].option, this.state.spin_data[this.state.prizeNo].player_name, this.state.spin_data[this.state.prizeNo].player_id, this.state.spin_data[this.state.prizeNo].player_pic, this.state.spin_data[this.state.prizeNo].player_cric_link,this.state.spin_data[this.state.prizeNo].icon_text);

    if(this.state.auction_spinner_computer_flag!=="2")
    {
      setTimeout(
        () =>     document.getElementById('a_sold_amount').focus()      ,
        700
      );
    }


  };

  showSellModal(random_sl, player_name, player_id, player_pic, player_cric_link,icon_text) {

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let series_id = params.get('i');
    //alert(random_sl)
    //    document.getElementById('i_sell_modal_html').innerHTML = "<h3>"+random_sl+"</h3>";


    //getPlayerProfile(group_fk,user_fk,'i_profile_modal',invite_code);
    //call API i_profile_modal
    //alert(group_fk + ' ' + user_fk)
    /*
    this.setState({
      show: !this.state.show
    });
    */
  };

  closeshowSell = e => {
    this.setState({
      showSell: false
    });

  };
    
    hideCricProfile = e => {
    
      document.getElementById("cric_profile_td").style.display="none";
      document.getElementById('a_sold_amount').focus() ;

  };


  closeEditshowSell = e => {
    this.setState({
      showEditSell: false
    });



  };



  componentDidMount() {

    var auction_spinner_computer_flag = localStorage.getItem('auction_spinner_computer_flag');
    if(auction_spinner_computer_flag==='' || auction_spinner_computer_flag  == null)
    {
      auction_spinner_computer_flag = 1;
    }
    var auction_display_flag = localStorage.getItem('auction_display_flag');
    if(auction_display_flag==='' || auction_display_flag  == null)
    {
      auction_display_flag = 0;
    }

    this.setState({
      auction_spinner_computer_flag:auction_spinner_computer_flag,
      auction_display_flag: parseInt(auction_display_flag)
    });

    //auction_display_flag

    this.callbasicapi();
    
    document.addEventListener('keydown', this.handleKeyPress);
  }

  handleKeyPress = (event) => {
    // Check if Alt + N is pressed
    //alert(event.key)
    if (event.altKey && event.which == 78) {
      // Trigger button click event
      
      document.getElementById('startspinbtn').click();
      //this.setState({ enter_manually: true });

    }
    else     if (event.altKey && event.which == 77) {
      // Trigger button click event
      
      this.setState({ enter_manually: 1 });
      setTimeout(
        () =>     document.getElementById('e_enter_manually').focus()      ,
        700
      );
      //this.setState({ x: true });

    }

    

    else if (event.altKey && event.which == 83) {
      // Trigger button click event
      
      document.getElementById('sellplayerbtn').click();
      //this.setState({ x: true });

    }

    

  };

  auction_sell_enter= (event) => {

    if(event.key == 'Enter'){
      document.getElementById('sellplayerbtn').click();
    }
  }
  
  auction_manual= (event) => {
    if(event.key == 'Enter'){
      //alert('Adding....');
      console.log(this.state.spin_data)
      var e_enter_manually  = document.getElementById('e_enter_manually').value;

      //this.state.prizeNo

      var array_index = this.state.spin_data.findIndex(item => item.option === e_enter_manually);
      
      if(array_index  === -1)
      {
        return;
      }
      
      this.setState({
        prizeNo:array_index
      });

      
      this.setState({
        x: false, prizeNo: 1, showSell: !this.state.showSell,
        prizeNo:array_index,
        selected_sl: this.state.spin_data[array_index].option,
        selected_new_player_id: this.state.spin_data[array_index].player_id,
        selected_player: this.state.spin_data[array_index].player_name,
        selected_player_pic : this.state.spin_data[array_index].player_pic,
        selected_cric_img: this.state.spin_data[array_index].cric_heroes_profile_img,
        cric_heroes_profile_link : this.state.spin_data[array_index].cric_heroes_profile_link,
        selected_cric_heroes_last_updated_on: this.state.spin_data[array_index].cric_heroes_last_updated_on,
        icon_text: this.state.spin_data[array_index].icon_text,
        selected_cric_batting_style: this.state.spin_data[array_index].cric_batting_style,
        selected_cric_bowling_style: this.state.spin_data[array_index].cric_bowling_style,
        selected_cric_matches: this.state.spin_data[array_index].cric_matches,
        selected_cric_runs: this.state.spin_data[array_index].cric_runs,
        selected_cric_wickets: this.state.spin_data[array_index].cric_wickets,
        selected_cric_tags: this.state.spin_data[array_index].cric_tags,
        selected_role: this.state.spin_data[array_index].role,
        selected_keeping: this.state.spin_data[array_index].keeping_flag,
        selected_district_name: this.state.spin_data[array_index].district_name,
        selected_previous_team_details: this.state.spin_data[array_index].previous_team_details

      });
      this.showSellModal(this.state.spin_data[array_index].option, this.state.spin_data[array_index].player_name, this.state.spin_data[array_index].player_id, this.state.spin_data[array_index].player_pic, this.state.spin_data[array_index].player_cric_link,this.state.spin_data[array_index].icon_text);
      if(this.state.auction_spinner_computer_flag!=="2")
      {
    
        setTimeout(
          () =>     document.getElementById('a_sold_amount').focus()      ,
          700
        );
      }
      
  }

  }

  onClickStartPin= (e) => {
    this.callbasicapi(1);
    //this.setState({ x: true });
  }

  onClickRandomTeam= (e) => {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let series_id = atob(params.get('id'));

    const post_data = { series_id: series_id};
    console.log(post_data)
    //      alert(group_id)
    //,{headers: {"Content-Type": "application/json"}}
    axios.post(global.config.app.backend_api_url + `Setteam/auto`, post_data, { withCredentials: true }
    )
      .then(res => {
        //const normalmembers = res.data;  
        console.log("after112")
        console.log(res.data)
        if (res.data.status == '0') {
          alert(res.data.message);
        }
        else {
          alert(res.data.message);
          this.setState({ showSell: false });
          this.callbasicapi();
        }

      });




  }

  getCurrentBid= (e) =>  {
    try{
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let series_id = atob(params.get('id'));

    const post_data = { series_id: series_id};
    //document.getElementById("right_div_for_bid").innerHTML = '';
    //console.log(post_data)
    //      alert(group_id)
    //,{headers: {"Content-Type": "application/json"}}
    axios.post(global.config.app.backend_api_url + `auction/get_current_bid`, post_data,
     { withCredentials: true,timeout: 3000 }
    )
      .then(res => {
        //const normalmembers = res.data;  
        //console.log(res.data)
        try{

          this.setState({
            teams_only: res.data.teams_only,
            sel_current_bid_amount: res.data.current_bid_amount
          });

            const current_bid_amount = res.data.current_bid_amount;
            //alert(current_bid_amount)
            // if(res.data.current_bid_teams_html!=='')
            // {
            //   document.getElementById('right_team_table').innerHTML = res.data.current_bid_teams_html;
            // }

            // const rows = document.querySelectorAll("tr");
            //   rows.forEach((row) => {
            //     const maxBidCell = row.querySelector(".teamlist_amount");
                
            //     if (maxBidCell) {
            //       const maxBidValue = parseFloat(maxBidCell.textContent);
            //       if (maxBidValue <= current_bid_amount) {
            //         row.querySelectorAll(".teamlist_right").forEach((cell) => {
            //           cell.classList.add("disabled_team");
            //         });
            //       } else {
            //         row.querySelectorAll(".teamlist_right").forEach((cell) => {
            //           cell.classList.remove("disabled_team");
            //         });
            //       }
            //     }
            //   });
              //document.getElementById("right_div_for_bid").innerHTML = res.data.current_bid_teams_html;
        }catch(Err)
        {
          
        }
      });
    }catch(Errr)
    {

    }
  }


  updateCurrentBid(current_bid_amount) {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let series_id = atob(params.get('id'));

    var current_bid_player  = this.state.selected_new_player_id;
   // alert(current_bid_player)
    var auction_spinner_computer_flag = localStorage.getItem('auction_spinner_computer_flag');
    

    const post_data = { series_id: series_id,current_bid_amount:current_bid_amount,current_bid_player:current_bid_player,
      auction_spinner_computer_flag:auction_spinner_computer_flag};
    //console.log(post_data)
    //      alert(group_id)
    //,{headers: {"Content-Type": "application/json"}}
    axios.post(global.config.app.backend_api_url + `auction/update_current_bid`, post_data, { withCredentials: true ,timeout: 5000}
    )
      .then(res => {
        //const normalmembers = res.data;  
        //console.log("current bid updated")
        //console.log(res.data)
        

      });




  }

  onClickSell = (e) => {

    var a_match_team_id = document.getElementById('a_match_team_id').value
    var a_sold_amount = document.getElementById('a_sold_amount').value
    document.getElementById("sellplayerbtn").style.display = "none";
    document.getElementById("loadergif").style.display = "";
    

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let series_id = atob(params.get('id'));
    var auction_spinner_computer_flag = localStorage.getItem('auction_spinner_computer_flag');

    const post_data = { series_id: series_id, match_team_fk: a_match_team_id, random_slno: this.state.selected_sl, auction_sold_amount: a_sold_amount
    ,auction_spinner_computer_flag:auction_spinner_computer_flag };
    console.log(post_data)
    //      alert(group_id)
    //,{headers: {"Content-Type": "application/json"}}
    axios.post(global.config.app.backend_api_url + `auction/sell_a_player`, post_data, { withCredentials: true }
    )
      .then(res => {
        document.getElementById("sellplayerbtn").style.display = "";
        document.getElementById("loadergif").style.display = "none";


        //const normalmembers = res.data;  
        console.log("after112")
        console.log(res.data)
        if (res.data.status == '0') {
          alert(res.data.message);
        }
        else {
          alert(res.data.message);
          this.setState({ showSell: false });
          this.callbasicapi();
          try
          {
            document.getElementById('e_enter_manually').value = '';
          }catch(Err)
          {

          }
        }

      });

    // alert('API to be called');
  }

  onClickEditSell = (e) => {

    var a_match_team_id = document.getElementById('e_a_match_team_id').value
    var a_sold_amount = document.getElementById('e_a_sold_amount').value

    document.getElementById("changeditbtn").style.display="none";
    document.getElementById("loadergif_change").style.display="";
    


    let search = window.location.search;
    let params = new URLSearchParams(search);
    let series_id = atob(params.get('id'));
    //alert(this.state.e_selected_sl)
    const post_data = { series_id: series_id, match_team_fk: a_match_team_id,user_fk:this.state.e_selected_user_fk, random_slno: this.state.e_selected_sl, new_sold_amount: a_sold_amount };
    console.log(post_data)
    //      alert(group_id)
    //,{headers: {"Content-Type": "application/json"}}
    axios.post(global.config.app.backend_api_url + `auction/change_team_of_a_sold_player`, post_data, { withCredentials: true }
    )
      .then(res => {
        document.getElementById("loadergif_change").style.display="none";
        document.getElementById("changeditbtn").style.display="";

        //const normalmembers = res.data;  
        console.log("after112")
        console.log(res.data)
        if (res.data.status == '0') {
          alert(res.data.message);
        }
        else {
          alert(res.data.message);
          this.setState({ showEditSell: false });
          this.callbasicapi();
        }

      });

    // alert('API to be called');
  }
  
  onClickReverseSoldPlayer = (e) => {

    if (window.confirm('Are you sure?') == false) {
      return false;
    }

    document.getElementById("changeswapplayer_rev").style.display="none";
    //document.getElementById("loadergif_change").style.display="";
    


    let search = window.location.search;
    let params = new URLSearchParams(search);
    let series_id = atob(params.get('id'));
    //alert(this.state.e_selected_sl)
    const post_data = { series_id: series_id, user_fk:this.state.e_selected_user_fk};
    console.log(post_data)
    //      alert(group_id)
    //,{headers: {"Content-Type": "application/json"}}
    axios.post(global.config.app.backend_api_url + `auction/undo_sold_player`, post_data, { withCredentials: true }
    )
      .then(res => {
        //document.getElementById("loadergif_change").style.display="none";
        document.getElementById("changeswapplayer_rev").style.display="";

        //const normalmembers = res.data;  
        console.log("after112")
        console.log(res.data)
        if (res.data.status == '0') {
          alert(res.data.message);
        }
        else {
          alert(res.data.message);
          this.setState({ showEditSell: false });
          this.callbasicapi();
        }

      });

    // alert('API to be called');
  }



  onClickSwapPlayer = (e) => {

    var e_new_user_mobile_number = document.getElementById('e_new_user_mobile_number').value

    document.getElementById("changeswapplayer").style.display="none";
    //document.getElementById("loadergif_change").style.display="";
    


    let search = window.location.search;
    let params = new URLSearchParams(search);
    let series_id = atob(params.get('id'));
    //alert(this.state.e_selected_sl)
    const post_data = { series_id: series_id, new_user_mobile_number: e_new_user_mobile_number,old_user_fk:this.state.e_selected_user_fk};
    console.log(post_data)
    //      alert(group_id)
    //,{headers: {"Content-Type": "application/json"}}
    axios.post(global.config.app.backend_api_url + `auction/swap_player_after_sold`, post_data, { withCredentials: true }
    )
      .then(res => {
        //document.getElementById("loadergif_change").style.display="none";
        document.getElementById("changeswapplayer").style.display="";

        //const normalmembers = res.data;  
        console.log("after112")
        console.log(res.data)
        if (res.data.status == '0') {
          alert(res.data.message);
        }
        else {
          alert(res.data.message);
          this.setState({ showEditSell: false });
          this.callbasicapi();
        }

      });

    // alert('API to be called');
  }


  onClickReverseUnSold = (user_fk, e) => {

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let series_id = atob(params.get('id'));
    const post_data = { series_id: series_id, user_fk: user_fk };
    console.log(post_data)
    document.getElementById("movependingbtn").style.display="none";
    document.getElementById("loadergif_unsold_pending").style.display="";
    
    //      alert(group_id)
    //,{headers: {"Content-Type": "application/json"}}
    axios.post(global.config.app.backend_api_url + `auction/move_unsold_to_pending`, post_data, { withCredentials: true }
    )
      .then(res => {
        document.getElementById("movependingbtn").style.display="";
        document.getElementById("loadergif_unsold_pending").style.display="none";
    
        //const normalmembers = res.data;  
        console.log("after112")
        console.log(res.data)
        if (res.data.status == '0') {
          alert(res.data.message);
        }
        else {
          alert(res.data.message);
          this.setState({ showSell: false });
          this.callbasicapi();
        }

      });

    // alert('API to be called');
  };

  togglePlayersListViewMode = () => {
    this.setState({
      playersListViewMode: this.state.playersListViewMode === 'normal' ? 'big_tile' : 'normal'
    });
  };

  handleImagePreview = (imageUrl) => {
    this.setState({
      previewImageUrl: imageUrl,
      previewImageOpen: true
    });
  };

  handleCloseImagePreview = () => {
    this.setState({
      previewImageOpen: false,
      previewImageUrl: null
    });
  };

  onClickAllPendingToUnSold = ( e) => {

    if (window.confirm('Are you sure?') == false) {
      return false;
    }
    
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let series_id = atob(params.get('id'));
    const post_data = { series_id: series_id };
    console.log(post_data)
    document.getElementById("unsoldbtn_rev_all_pnd").style.display="none";
    
    //      alert(group_id)
    //,{headers: {"Content-Type": "application/json"}}
    axios.post(global.config.app.backend_api_url + `auction/move_all_pending_to_unsold`, post_data, { withCredentials: true }
    )
      .then(res => {
        document.getElementById("unsoldbtn_rev_all_pnd").style.display="";
    
        //const normalmembers = res.data;  
        console.log("after112")
        console.log(res.data)
        if (res.data.status == '0') {
          alert(res.data.message);
        }
        else {
          alert(res.data.message);
          this.setState({ showSell: false });
          this.callbasicapi();
        }

      });

    // alert('API to be called');
  };
  onClickAllReverseUnSold = ( e) => {

    if (window.confirm('Are you sure?') == false) {
      return false;
    }
    
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let series_id = atob(params.get('id'));
    const post_data = { series_id: series_id };
    console.log(post_data)
    document.getElementById("unsoldbtn_rev_all").style.display="none";
    
    //      alert(group_id)
    //,{headers: {"Content-Type": "application/json"}}
    axios.post(global.config.app.backend_api_url + `auction/all_move_unsold_to_pending`, post_data, { withCredentials: true }
    )
      .then(res => {
        document.getElementById("unsoldbtn_rev_all").style.display="";
    
        //const normalmembers = res.data;  
        console.log("after112")
        console.log(res.data)
        if (res.data.status == '0') {
          alert(res.data.message);
        }
        else {
          alert(res.data.message);
          this.setState({ showSell: false });
          this.callbasicapi();
        }

      });

    // alert('API to be called');
  };

  onClickUnSold = (e) => {
    if (window.confirm('Are you sure?') == false) {
      return false;
    }
    var a_match_team_id = document.getElementById('a_match_team_id').value
    var a_sold_amount = document.getElementById('a_sold_amount').value
    document.getElementById("unsoldbtn").style.display="none";
    document.getElementById("loadergif_unsold").style.display="";
    
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let series_id = atob(params.get('id'));

    const post_data = { series_id: series_id, match_team_fk: a_match_team_id, random_slno: this.state.selected_sl, auction_sold_amount: a_sold_amount };
    console.log(post_data)
    //      alert(group_id)
    //,{headers: {"Content-Type": "application/json"}}
    axios.post(global.config.app.backend_api_url + `auction/unsold`, post_data, { withCredentials: true }
    )
      .then(res => {
        document.getElementById("unsoldbtn").style.display="";
        document.getElementById("loadergif_unsold").style.display="none";
        //const normalmembers = res.data;  
        console.log("after112")
        console.log(res.data)
        if (res.data.status == '0') {
          alert(res.data.message);
        }
        else {
          alert(res.data.message);
          this.setState({ showSell: false });
          this.callbasicapi();
          try
          {
            document.getElementById('e_enter_manually').value = '';
          }catch(Err)
          {

          }
        }

      });

    // alert('API to be called');
  }

  onChangeImgFlag = (e) => {
    
    var auction_send_image_flag = document.getElementById('auction_send_image_flag').value

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let series_id = atob(params.get('id'));

    const post_data = { series_id: series_id, auction_send_image_flag: auction_send_image_flag};
    console.log(post_data)
    //      alert(group_id)
    //,{headers: {"Content-Type": "application/json"}}
    axios.post(global.config.app.backend_api_url + `auction/update_image_flag`, post_data, { withCredentials: true }
    )
      .then(res => {
        //const normalmembers = res.data;  
        console.log("after112")
        console.log(res.data)
        

      });

    // alert('API to be called');
  }

  onChangeSpinnerCOmputerFlag = (e) => {
    
    var auction_spinner_computer_flag = document.getElementById('auction_spinner_computer_flag').value
    localStorage.setItem("auction_spinner_computer_flag", auction_spinner_computer_flag);

    this.setState({
      auction_spinner_computer_flag:auction_spinner_computer_flag
    });


    // alert('API to be called');
  }
  
  onChangeSellAmt = (e) => {
    
    var add_sell_amt_in_notificatioin = document.getElementById('add_sell_amt_in_notificatioin').value

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let series_id = atob(params.get('id'));

    const post_data = { series_id: series_id, add_sell_amt_in_notificatioin: add_sell_amt_in_notificatioin};
    console.log(post_data)
    //      alert(group_id)
    //,{headers: {"Content-Type": "application/json"}}
    axios.post(global.config.app.backend_api_url + `auction/update_add_sell_amt_in_notificatioin`, post_data, { withCredentials: true }
    )
      .then(res => {
        //const normalmembers = res.data;  
        console.log("after112")
        console.log(res.data)
        

      });

    // alert('API to be called');
  }

  onChangeDisplayFlag = (e) => {
    var auction_display_flag = document.getElementById('auction_display_flag').value
    localStorage.setItem('auction_display_flag', auction_display_flag);
    this.setState({
      auction_display_flag: parseInt(auction_display_flag)
    });
  }


  callbasicapi(startpin = 0) {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let series_id = atob(params.get('id'));

    var auction_spinner_computer_flag = localStorage.getItem('auction_spinner_computer_flag');

    const post_data = { series_id: series_id ,auction_spinner_computer_flag:auction_spinner_computer_flag,startpin:startpin};

    const headers = {
      'Content-Type': 'application/json'
    }

    axios.post(global.config.app.backend_api_url + `auction/get_current_auction_status/`, post_data, { headers: headers, withCredentials: true }
    )
      .then(res => {
        //const normalmembers = res.data;  
        console.log("after112d")
        var status = res.data.status;
        var message = res.data.message;
        if (status == 0) {
          console.log(message);
          //return
        }
        var auction_details = res.data.auction_details;
        var main_auction_details = auction_details.main[0];
        console.log(main_auction_details)
        var teams_details = auction_details.teams;
        var teams_only = auction_details.teams_only;
        var sold_players = auction_details.sold;
        var unsold_players = auction_details.unsold;
        var pending_players = auction_details.pending;
        var pending_sl = auction_details.pending_sl;
        var random_sl = auction_details.random;

        let spin_data = [];
        const listitems = pending_sl;
        console.log("slno:" + random_sl.random_number);

        console.log("populating")
        if (typeof (listitems) != "undefined") {

          for (let i = 0; i < listitems.length; i++) {
            spin_data.push({ option: listitems[i].option, player_id: listitems[i].user_id, player_name: listitems[i].full_name, player_pic: listitems[i].profile_pic, player_cric_link: listitems[i].cric_heroes_profile_link,cric_heroes_profile_link:listitems[i].cric_heroes_profile_link, 
              cric_heroes_profile_img: listitems[i].cric_heroes_profile_img, 
              icon_text: listitems[i].icon_text,
              cric_batting_style: listitems[i].cric_batting_style,
              cric_bowling_style: listitems[i].cric_bowling_style,
              cric_matches: listitems[i].cric_matches,
              cric_runs: listitems[i].cric_runs,
              cric_wickets: listitems[i].cric_wickets,
              cric_tags: listitems[i].cric_tags,
              role: listitems[i].role,
              keeping_flag: listitems[i].keeping_flag,
              district_name: listitems[i].district_name,
              previous_team_details: listitems[i].previous_team_details,
              
              cric_heroes_last_updated_on: listitems[i].cric_heroes_last_updated_on, style: { backgroundColor: listitems[i].bg, textColor: "white" } });

          }
        }
        var xvalue = false; //for spinner
        if(startpin==1)
        {
          xvalue    =true;
        }
        console.log(auction_details.amounts)
        //org_items
        this.setState({
          main_auction_details: main_auction_details, teams_details: teams_details, sold_players: sold_players,
          unsold_players: unsold_players, pending_players: pending_players, spin_data: spin_data, prizeNo: Number(random_sl.random_number)
          ,x:xvalue,org_items:auction_details.amounts,items:auction_details.amounts,
          teams_only: teams_only, unique_count: res.data.unique_count, total_count: res.data.total_count
        });

        

      });

  }


  componentWillUnmount() {
    clearInterval(this.interval);
  }
  render() {

    const { value, items } = this.state;

    return (

      <DashboardLayout>
        <Helmet>
          <title>Auction | {global.config.app.name}</title>
          <meta
            name="description"
            content="Join Our Cricket Team - Experience the thrill of competitive cricket and be part of a supportive community. Sign up now and showcase your skills on the field."
          />
          <meta
            name="keywords"
            content="Cricket, team, join, competitive, skills, community, sign up, field"
          />
        </Helmet>
       {
         /*
         <DashboardNavbar />
         */
       } 
        <Card>

          <SoftBox my={3}>
            <Grid container spacing={3} justifyContent="center" alignItems="center">
              <Grid item xs={12} md={12}>
                {
                  //  alert(this.state.main_auction_details.pending_count)
                  (() => {

                    if (this.state.spin_data.length > 0 && this.state.main_auction_details.team_max_pocket_size>0) {

                      let search = window.location.search;
                      let params = new URLSearchParams(search);
                      let manual = params.get('manual');
                  
                      return (
                        <SoftBox pt={2} pb={3} px={3}>
                          <SpinnerWrapStyle className="App">
                            <Wheel
                              prizeNumber={Number(this.state.prizeNo)}
                              mustStartSpinning={this.state.x}
                              data={this.state.spin_data}
                              backgroundColors={["#c2db62", "#5fbd5a"]}
                              textColors={["#ffffff"]}
                              onStopSpinning={this.stopSpin}
                              radiusLineWidth={1}
                              spinDuration={0.1}
                              outerBorderWidth={1}
                            />

                            <SoftButton id="startspinbtn" variant="gradient" size="small" color="success" onClick={this.onClickStartPin}>
                              Start Spin
                            </SoftButton>
                            {
                  //  alert(this.state.main_auction_details.pending_count)
                  (() => {

                    if (manual == '1' || this.state.enter_manually == '1') {
                            return (
                            <SoftBox pt={2} pb={3} px={3}>
                            <SoftInput placeholder="Enter manually" name="e_enter_manually" onKeyPress={this.auction_manual} id="e_enter_manually" inputProps={{ maxLength: 3 }} />
                            </SoftBox>
                            )
                    }
                  })()
                }

                          </SpinnerWrapStyle>


                        </SoftBox>

                      )
                    }

                  })()

                }

                  {
                  //  alert(this.state.main_auction_details.pending_count)
                  (() => {

                    if (this.state.main_auction_details.team_max_pocket_size==0) {
                      return (
                        
                            
<SoftBox pt={2} pb={3} px={3}>
                            <SoftButton variant="gradient" size="small" color="success" onClick={this.onClickRandomTeam}>
                              Generate Random Team
                            </SoftButton>

                        </SoftBox>

                      )
                    }

                  })()

                }

              </Grid>

              <Grid item xs={12} md={12}>
                <SoftBox p={1} className="auction-overview">
                  <div className="overview-title">{this.state.main_auction_details.group_name} - {this.state.main_auction_details.series_name}</div>
                  <div className="stats-grid">
                    <div className="stat-card"><div className="stat-label">No. of Teams</div><div className="stat-value">{this.state.main_auction_details.no_of_teams}</div></div>
                    <div className="stat-card"><div className="stat-label">Players in auction</div><div className="stat-value">{this.state.main_auction_details.count_players_in_auction}</div></div>
                    <div className="stat-card"><div className="stat-label">Team wallet size</div><div className="stat-value">{this.state.main_auction_details.team_max_pocket_size}</div></div>
                    <div className="stat-card"><div className="stat-label">Player base price</div><div className="stat-value">{this.state.main_auction_details.player_base_price}</div></div>
                    <div className="stat-card"><div className="stat-label">Pending players</div><div className="stat-value">{this.state.main_auction_details.pending_count}</div></div>
                    <div className="stat-card"><div className="stat-label">Unsold players</div><div className="stat-value">{this.state.main_auction_details.unsold_count}</div></div>
                    <div className="stat-card"><div className="stat-label">Sold players</div><div className="stat-value">{this.state.main_auction_details.sold_count}</div></div>
                  </div>
                </SoftBox>
                <SoftBox display="flex" justifyContent="space-between" alignItems="center"  p={1} pb={0}>
                  Team stats:
                </SoftBox>

                
                
                <SoftBox mb={4} xs={4} md={4}  alignItems="center" p={2} >

                  {
                    (() => {
                      const listitems = this.state.teams_details;
                      //console.log(listitems);
                      //console.log("populating")
                      if (typeof (listitems) != "undefined") {
                        //console.log(listitems)
                        const rows = [];
                        for (let i = 0; i < listitems.length; i++) {
                          //team_name,  team_logo, current_wallet_balance, current_players_count, players

                          rows.push(<Team team_max_playes_count={this.state.main_auction_details.team_max_playes_count} pr={3} max_bid_for_a_player={listitems[i].max_bid_for_a_player} current_players_count={listitems[i].current_players_count} current_wallet_balance={listitems[i].current_wallet_balance} team_logo={listitems[i].team_logo} players={listitems[i].players}  team_name={listitems[i].team_name} key={i} />);
                        }
                        return rows;
                      }

                    })()

                  }

                </SoftBox>

                {/* Hit Counter Stats */}
                <SoftBox mb={3} p={2}>
                  <Card sx={{ border: '2px solid #28a745' }}>
                    <SoftBox 
                      sx={{ 
                        background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                        color: 'white',
                        p: 2,
                        borderRadius: '8px 8px 0 0'
                      }}
                    >
                      <SoftTypography variant="h6" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        📊 Live Viewers
                      </SoftTypography>
                    </SoftBox>
                    <SoftBox p={2}>
                      <Grid container spacing={2} textAlign="center">
                        <Grid item xs={6}>
                          <SoftTypography variant="h4" color="primary" fontWeight="bold">
                            {this.state.unique_count || 0}
                          </SoftTypography>
                          <SoftTypography variant="caption" color="text" fontWeight="medium">
                            Unique Viewers
                          </SoftTypography>
                        </Grid>
                        <Grid item xs={6}>
                          <SoftTypography variant="h4" color="success" fontWeight="bold">
                            {this.state.total_count || 0}
                          </SoftTypography>
                          <SoftTypography variant="caption" color="text" fontWeight="medium">
                            Total Page Views
                          </SoftTypography>
                        </Grid>
                      </Grid>
                    </SoftBox>
                  </Card>
                </SoftBox>

              </Grid>
            </Grid>
          </SoftBox>


          <SoftBox display="flex" alignItems="flex-start" p={1} className="players-panel">
            <Box sx={{display: 'flex', flexDirection: 'column', }} p={1}>
              <SoftBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                <div className="section-title">
                  <FaListUl />&nbsp;Players list with stats: Pending Players
                </div>
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.state.playersListViewMode === 'big_tile'}
                      onChange={this.togglePlayersListViewMode}
                      size="small"
                    />
                  }
                  label={this.state.playersListViewMode === 'normal' ? 'Normal' : 'Big Tile'}
                  sx={{ margin: 0 }}
                />
              </SoftBox> 
                <div>
                  {
                    (() => {
                      const listitems = this.state.pending_players;
                      //  console.log(listitems);
                      // console.log("populating")
                      if (typeof (listitems) != "undefined") {
                        //console.log(listitems)
                        const rows = [];
                        for (let i = 0; i < listitems.length; i++) {
                          //team_name,  team_logo, current_wallet_balance, current_players_count, players

                          rows.push(<PendingPlayer user_id={listitems[i].user_id} icon_text ={listitems[i].icon_text} player_name={listitems[i].full_name} sl_no={listitems[i].sl_no} profile_pic={listitems[i].profile_pic} cric_heroes_profile_link={listitems[i].cric_heroes_profile_link} key={i}  onClickPlayerProfileToSell={this.onClickPlayerProfileToSell} viewMode={this.state.playersListViewMode} onImagePreview={this.handleImagePreview} />);
                        }
                        if (this.state.playersListViewMode === 'big_tile') {
                          return (
                            <SoftBox 
                              component="ul" 
                              sx={{ 
                                display: 'grid', 
                                gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                                gap: 2,
                                p: 0, 
                                m: 0,
                                maxHeight: '600px',
                                overflowY: 'auto'
                              }}
                            >
                              {rows}
                            </SoftBox>
                          );
                        }
                        return <SoftBox component="ul" display="flex" flexDirection="column" p={0} m={0}>{rows}</SoftBox>;
                      }

                    })()

                  }

                {
                  (() => {
                    const listitems = this.state.pending_players;

                    if (typeof (listitems) != "undefined") {
                    if(listitems.length > 0)
                    {

                    
                      return(
              <SoftButton variant="gradient" id="unsoldbtn_rev_all_pnd" size="small" color="error" className="section-action" onClick={this.onClickAllPendingToUnSold}>
                      Move all pending to unsold?</SoftButton>
                    )
                    }
                  }
                  })()

              }

                </div>
            </Box>
            <Box sx={{display: 'flex', flexDirection: 'column' }} p={1}>
              <SoftBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                <div className="section-title">
                  <FaTimesCircle />&nbsp;Unsold Players
                </div>
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.state.playersListViewMode === 'big_tile'}
                      onChange={this.togglePlayersListViewMode}
                      size="small"
                    />
                  }
                  label={this.state.playersListViewMode === 'normal' ? 'Normal' : 'Big Tile'}
                  sx={{ margin: 0 }}
                />
              </SoftBox>

              <div>
                {
                  (() => {
                    const listitems = this.state.unsold_players;
                    // console.log(listitems);
                    // console.log("populating")
                    if (typeof (listitems) != "undefined") {
                      //console.log(listitems)
                      const rows = [];
                      for (let i = 0; i < listitems.length; i++) {
                        //team_name,  team_logo, current_wallet_balance, current_players_count, players

                        rows.push(<UnsoldPlayer user_id={listitems[i].user_id} player_name={listitems[i].full_name} sl_no={listitems[i].sl_no} profile_pic={listitems[i].profile_pic} cric_heroes_profile_link={listitems[i].cric_heroes_profile_link} key={i} viewMode={this.state.playersListViewMode} onImagePreview={this.handleImagePreview} />);
                      }
                      if (this.state.playersListViewMode === 'big_tile') {
                        return (
                          <SoftBox 
                            component="ul" 
                            sx={{ 
                              display: 'grid', 
                              gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                              gap: 2,
                              p: 0, 
                              m: 0,
                              maxHeight: '600px',
                              overflowY: 'auto'
                            }}
                          >
                            {rows}
                          </SoftBox>
                        );
                      }
                      return <SoftBox component="ul" display="flex" flexDirection="column" p={0} m={0}>{rows}</SoftBox>;
                    }

                  })()

                }
              </div>

              {
                  (() => {
                    const listitems = this.state.unsold_players;

                    if (typeof (listitems) != "undefined") {
                    if(listitems.length > 0)
                    {

                    
                      return(
              <SoftButton variant="gradient" id="unsoldbtn_rev_all" size="small" color="error" className="section-action" onClick={this.onClickAllReverseUnSold}>
                      Move all unsold to pending?</SoftButton>
                    )
                    }
                  }
                  })()

              }
            </Box>

            


          </SoftBox>



          <SoftBox mb={2}>
Auction Live Streaming <br></br>
<SoftTypography
          variant="button"
          fontWeight="regular"
          
          sx={{ cursor: "poiner", userSelect: "none" }}
        >
          Spinner computer ?:
        </SoftTypography>

      <FormSelect size="sm" className="mb-9" name="auction_spinner_computer_flag" id="auction_spinner_computer_flag" onChange={this.onChangeSpinnerCOmputerFlag}>
  <option value="1" selected={(this.state.auction_spinner_computer_flag === "1") ? 'selected' : ''}>Yes</option>
  <option value="0" selected={(this.state.auction_spinner_computer_flag === "0") ? 'selected' : ''}>No</option>
  <option value="2" selected={(this.state.auction_spinner_computer_flag === "2") ? 'selected' : ''}>Spinner Only</option>

</FormSelect>
</SoftBox>





          <SoftBox mb={2}>

<SoftTypography
          variant="button"
          fontWeight="regular"
          
          sx={{ cursor: "poiner", userSelect: "none" }}
        >
          Send with player image ?:
        </SoftTypography>

      <FormSelect size="sm" className="mb-9" name="auction_send_image_flag" id="auction_send_image_flag" onChange={this.onChangeImgFlag}>
  <option value="1" selected={(this.state.main_auction_details.auction_send_image_flag === "1") ? 'selected' : ''}>Yes</option>
  <option value="0" selected={(this.state.main_auction_details.auction_send_image_flag === "0") ? 'selected' : ''}>No</option>
</FormSelect>
</SoftBox>


<SoftBox mb={2}>

<SoftTypography
          variant="button"
          fontWeight="regular"
          
          sx={{ cursor: "poiner", userSelect: "none" }}
        >
          Add sell amount in notification ?:
        </SoftTypography>

      <FormSelect size="sm" className="mb-9" name="add_sell_amt_in_notificatioin" id="add_sell_amt_in_notificatioin" onChange={this.onChangeSellAmt}>
  <option value="1" selected={(this.state.main_auction_details.add_sell_amt_in_notificatioin === "1") ? 'selected' : ''}>Yes</option>
  <option value="0" selected={(this.state.main_auction_details.add_sell_amt_in_notificatioin === "0") ? 'selected' : ''}>No</option>
</FormSelect>
</SoftBox>

<SoftBox mb={2}>

<SoftTypography
          variant="button"
          fontWeight="regular"
          
          sx={{ cursor: "poiner", userSelect: "none" }}
        >
          Display Layout:
        </SoftTypography>

      <FormSelect size="sm" className="mb-9" name="auction_display_flag" id="auction_display_flag" onChange={this.onChangeDisplayFlag}>
  <option value="0" selected={(this.state.auction_display_flag === 0) ? 'selected' : ''}>4 Column Layout (Default)</option>
  <option value="1" selected={(this.state.auction_display_flag === 1) ? 'selected' : ''}>3 Column Layout (More Teams)</option>
</FormSelect>
</SoftBox>

<SoftBox mb={2}>


&nbsp;
{
                (() => {


                  

                    var link_to_create = "/makeauction";
                    var querystring = "?id="+btoa(this.state.main_auction_details.group_id)+"&sid="+btoa(this.state.main_auction_details.series_id);
                   // alert(querystring)

                   return (

                    <Link to={{pathname:link_to_create,search:querystring} }>
                      Back to auction
                      </Link>

                    
                    
                   )
                   

                   
                     

                  })()
        
              }


</SoftBox>


        </Card>
        <Footer />

        <Modal
          isOpen={this.state.showSell}
          onRequestClose={this.closeshowSell}
          style={customStyles}
          shouldCloseOnOverlayClick={false}
          contentLabel="Modal"

        >

          <div id='i_sell_modal_html'>
          <div style={{marginBottom:'10px'}} >

          

                  

          {
            (() => {
              if (this.state.auction_display_flag === 0) {
                // 4 Column Layout (Original)
                return (
                  <table cellspacing="0" width="100%" cellpadding="0" >
                    <tr>
                      <td width="30%" valign='top'>
                        {/* Enhanced Professional Image Frame */}
                        <div style={{ 
                          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          borderRadius: '20px',
                          padding: '20px',
                          boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                          border: '1px solid rgba(255,255,255,0.2)',
                          backdropFilter: 'blur(10px)',
                          position: 'relative',
                          overflow: 'hidden',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                          {/* Decorative Background Elements */}
                          <div style={{
                            position: 'absolute',
                            top: '-50px',
                            right: '-50px',
                            width: '100px',
                            height: '100px',
                            background: 'rgba(255,255,255,0.1)',
                            borderRadius: '50%',
                            zIndex: 1
                          }}></div>
                          <div style={{
                            position: 'absolute',
                            bottom: '-30px',
                            left: '-30px',
                            width: '60px',
                            height: '60px',
                            background: 'rgba(255,255,255,0.05)',
                            borderRadius: '50%',
                            zIndex: 1
                          }}></div>
                          
                          {/* Image Container */}
                          <div style={{
                            background: 'rgba(255,255,255,0.95)',
                            borderRadius: '15px',
                            padding: '10px',
                            boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
                            border: '3px solid rgba(255,255,255,0.3)',
                            position: 'relative',
                            zIndex: 2
                          }}>
                            {
                              (() => {
                                const props = {width: 300, zoomPosition:'original', zoomWidth: '300', img: this.state.selected_player_pic ? (this.state.selected_player_pic):(team_player_2)};
                                return (<div className="image-zoom-container">
                                  <ReactImageZoom {...props} />
                                </div>)
                              })()
                            }
                          </div>
                          
                          {/* Subtle glow effect */}
                          <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'linear-gradient(135deg, rgba(102,126,234,0.1) 0%, rgba(118,75,162,0.1) 100%)',
                            borderRadius: '20px',
                            zIndex: 0
                          }}></div>
                        </div>
                      </td>
                      <td width="30%" valign="top">
                        {/* Enhanced Professional Player Details Card */}
                        <div style={{ 
                          borderRadius: '20px',
                          padding: '20px',
                          boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                          border: '1px solid rgba(255,255,255,0.2)',
                          backdropFilter: 'blur(10px)',
                          position: 'relative',
                          overflow: 'hidden',
                          marginTop: '5px'
                        }}>
                          {/* Decorative Background Elements */}
                          <div style={{
                            position: 'absolute',
                            top: '-50px',
                            right: '-50px',
                            width: '100px',
                            height: '100px',
                            background: 'rgba(255,255,255,0.1)',
                            borderRadius: '50%',
                            zIndex: 1
                          }}></div>
                          <div style={{
                            position: 'absolute',
                            bottom: '-30px',
                            left: '-30px',
                            width: '60px',
                            height: '60px',
                            background: 'rgba(255,255,255,0.05)',
                            borderRadius: '50%',
                            zIndex: 1
                          }}></div>
                          
                          {/* Player Number Badge */}
                          <div style={{ 
                            position: 'relative',
                            zIndex: 2,
                            textAlign: 'center',
                            marginBottom: '15px'
                          }}>
                            {
                              (() => {
                                var blank_page= global.config.app.backend_api_url + 'playerview?img='+this.state.selected_player_pic+'&sl='+this.state.selected_sl+'&name='+this.state.selected_player+'&cric='+this.state.selected_cric_img;
                                return (
                                  <a target="_blank" href={blank_page} style={{textDecoration: 'none'}}>
                                    <div style={{
                                      background: 'linear-gradient(45deg, #ff6b6b, #ee5a24)',
                                      color: 'white',
                                      fontSize: '22px',
                                      fontWeight: 'bold',
                                      padding: '8px 16px',
                                      borderRadius: '25px',
                                      display: 'inline-block',
                                      boxShadow: '0 8px 20px rgba(255,107,107,0.4)',
                                      border: '2px solid rgba(255,255,255,0.3)',
                                      textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                                      transition: 'all 0.3s ease',
                                      cursor: 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                      e.target.style.transform = 'scale(1.05)';
                                      e.target.style.boxShadow = '0 12px 25px rgba(255,107,107,0.6)';
                                    }}
                                    onMouseLeave={(e) => {
                                      e.target.style.transform = 'scale(1)';
                                      e.target.style.boxShadow = '0 8px 20px rgba(255,107,107,0.4)';
                                    }}>
                                      {this.state.selected_sl}
                                    </div>
                                  </a>
                                )
                              })()
                            }
                          </div>
                          
                          {/* Player Name Card */}
                          <div style={{ 
                            position: 'relative',
                            zIndex: 2,
                            textAlign: 'center',
                            marginBottom: '20px'
                          }}>
                            <div style={{
                              background: 'rgba(255,255,255,0.95)',
                              color: '#2c3e50',
                              fontSize: '24px',
                              fontWeight: 'bold',
                              padding: '15px 20px',
                              borderRadius: '15px',
                              boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
                              border: '2px solid rgba(255,255,255,0.3)',
                              textTransform: 'uppercase',
                              letterSpacing: '1px',
                              textShadow: '1px 1px 2px rgba(0,0,0,0.1)'
                            }}>
                              {this.state.selected_player}
                            </div>
                          </div>
                          
                          {/* Player Stats Container */}
                          <div style={{ 
                            position: 'relative',
                            zIndex: 2,
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '6px'
                          }}>
                            {this.state.icon_text && this.state.icon_text !== '' && this.state.icon_text != null && (
                              <div style={{
                                background: 'rgba(255,255,255,0.9)',
                                color: '#2c3e50',
                                padding: '6px 12px',
                                borderRadius: '8px',
                                fontSize: '13px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                border: '1px solid rgba(255,255,255,0.3)',
                                flex: '0 0 auto',
                                whiteSpace: 'nowrap'
                              }}>
                                {this.state.icon_text}
                              </div>
                            )}
                            
                            {this.state.selected_role && this.state.selected_role !== '' && this.state.selected_role != null && (
                              <div style={{
                                background: 'rgba(255,255,255,0.9)',
                                color: '#2c3e50',
                                padding: '6px 12px',
                                borderRadius: '8px',
                                fontSize: '13px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                border: '1px solid rgba(255,255,255,0.3)',
                                flex: '0 0 auto',
                                whiteSpace: 'nowrap'
                              }}>
                                Role: {this.state.selected_role}
                              </div>
                            )}
                            
                            {this.state.selected_cric_batting_style && this.state.selected_cric_batting_style !== '' && this.state.selected_cric_batting_style != null && (
                              <div style={{
                                background: 'rgba(200,230,201,0.9)',
                                color: '#4caf50',
                                padding: '6px 12px',
                                borderRadius: '8px',
                                fontSize: '13px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                border: '1px solid rgba(255,255,255,0.3)',
                                flex: '0 0 auto',
                                whiteSpace: 'nowrap'
                              }}>
                                {this.state.selected_cric_batting_style}
                              </div>
                            )}
                            
                            {this.state.selected_cric_bowling_style && this.state.selected_cric_bowling_style !== '' && this.state.selected_cric_bowling_style != null && (
                              <div style={{
                                background: 'rgba(227,242,253,0.9)',
                                color: '#1976d2',
                                padding: '6px 12px',
                                borderRadius: '8px',
                                fontSize: '13px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                border: '1px solid rgba(255,255,255,0.3)',
                                flex: '0 0 auto',
                                whiteSpace: 'nowrap'
                              }}>
                                {this.state.selected_cric_bowling_style}
                              </div>
                            )}
                            
                            {this.state.selected_cric_matches && this.state.selected_cric_matches !== '' && this.state.selected_cric_matches != null && (
                              <div style={{
                                background: 'rgba(255,243,224,0.9)',
                                color: '#e64a19',
                                padding: '6px 12px',
                                borderRadius: '8px',
                                fontSize: '13px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                border: '1px solid rgba(255,255,255,0.3)',
                                flex: '0 0 auto',
                                whiteSpace: 'nowrap'
                              }}>
                                Matches: {this.state.selected_cric_matches}
                              </div>
                            )}
                            
                            {this.state.selected_cric_runs && this.state.selected_cric_runs !== '' && this.state.selected_cric_runs != null && (
                              <div style={{
                                background: 'rgba(255,224,178,0.9)',
                                color: '#f4511e',
                                padding: '6px 12px',
                                borderRadius: '8px',
                                fontSize: '13px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                border: '1px solid rgba(255,255,255,0.3)',
                                flex: '0 0 auto',
                                whiteSpace: 'nowrap'
                              }}>
                                Runs: {this.state.selected_cric_runs}
                              </div>
                            )}
                            
                            {this.state.selected_cric_wickets && this.state.selected_cric_wickets !== '' && this.state.selected_cric_wickets != null && (
                              <div style={{
                                background: 'rgba(243,229,245,0.9)',
                                color: '#8e24aa',
                                padding: '6px 12px',
                                borderRadius: '8px',
                                fontSize: '13px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                border: '1px solid rgba(255,255,255,0.3)',
                                flex: '0 0 auto',
                                whiteSpace: 'nowrap'
                              }}>
                                Wickets: {this.state.selected_cric_wickets}
                              </div>
                            )}
                            
                            {this.state.selected_keeping && this.state.selected_keeping !== '' && this.state.selected_keeping != null && (
                              <div style={{
                                background: 'rgba(255,235,238,0.9)',
                                color: '#c62828',
                                padding: '6px 12px',
                                borderRadius: '8px',
                                fontSize: '13px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                border: '1px solid rgba(255,255,255,0.3)',
                                flex: '0 0 auto',
                                whiteSpace: 'nowrap'
                              }}>
                                Keeping: {this.state.selected_keeping}
                              </div>
                            )}
                            
                            {this.state.selected_district_name && this.state.selected_district_name !== '' && this.state.selected_district_name != null && (
                              <div style={{
                                background: 'rgba(225,245,254,0.9)',
                                color: '#0277bd',
                                padding: '6px 12px',
                                borderRadius: '8px',
                                fontSize: '13px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                border: '1px solid rgba(255,255,255,0.3)',
                                flex: '0 0 auto',
                                whiteSpace: 'nowrap'
                              }}>
                                District: {this.state.selected_district_name} 
                              </div>
                            )}
                            
                            {this.state.selected_previous_team_details && this.state.selected_previous_team_details !== '' && this.state.selected_previous_team_details != null && (
                              <div style={{
                                background: 'rgba(255,249,196,0.9)',
                                color: '#f57c00',
                                padding: '6px 12px',
                                borderRadius: '8px',
                                fontSize: '13px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                border: '1px solid rgba(255,255,255,0.3)',
                                flex: '0 0 auto',
                                whiteSpace: 'nowrap'
                              }}>
                                Current Club: {this.state.selected_previous_team_details}
                              </div>
                            )}
                          </div>
                          
                          {/* Subtle glow effect */}
                          <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'linear-gradient(135deg, rgba(102,126,234,0.1) 0%, rgba(118,75,162,0.1) 100%)',
                            borderRadius: '20px',
                            zIndex: 0
                          }}></div>
                        </div>
                      </td>
                      <td  width="35%" valign="top" className="team-summary-table" id="right_team_table" >
                        <div style={{ position: 'relative' }}>
                          <div className="team-summary-header">
                            <span style={{ fontSize: '14px', marginRight: '10px' }}>🏏</span>
                            <span>Team Summary</span>
                          </div>
                          <div style={{ 
                            filter: this.state.main_auction_details.hide_team_summary_info === "1" ? 'blur(3px)' : 'none',
                            transition: 'filter 0.3s ease'
                          }}>
                            <table className="team-table" style={{ fontSize: "11px", border: "1px solid #ddd", width: '100%' }}>
                          <thead>
                            <tr>
                              <th style={{ width: '60%' }}>Team Name</th>
                              <th style={{ width: '20%' }}>Max Bid</th>
                              <th style={{ width: '20%' }}>Count</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              (() => {
                                const listitems = this.state.teams_only;
                                const from_db_current_bid_amount = this.state.sel_current_bid_amount;

                                if (typeof (listitems) != "undefined") {
                                  return listitems.map((team, i) => {
                                    const teamlist_completed = team.current_players_count === team.team_max_playes_count ? 'teamlist_completed' : '';
                                    const teamlist_disabled = parseInt(from_db_current_bid_amount) >= parseInt(team.max_bid_for_a_player) ? 'disabled_team' : '';
                                    
                                    return (
                                      <tr className="team-row" key={i}>
                                        <td className={`team-name-cell teamlist_right ${teamlist_completed} ${teamlist_disabled}`}>
                                          {team.team_name.length > 18 ? team.team_name.slice(0, 16) + '..' : team.team_name}
                                        </td>
                                        <td className={`max-bid-cell teamlist_right teamlist_amount ${teamlist_completed} ${teamlist_disabled}`}>
                                          {team.max_bid_for_a_player}
                                        </td>
                                        <td className={`teamlist_right ${teamlist_completed} ${teamlist_disabled}`}>
                                          {team.current_players_count}/{team.team_max_playes_count}
                                        </td>
                                      </tr>
                                    );
                                  });
                                }
                              })()
                            }
                          </tbody>
                            </table>
                          </div>
                          {/* Upgrade Message Overlay */}
                          {this.state.main_auction_details.hide_team_summary_info === "1" && (
                            <div style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              background: 'rgba(255, 255, 255, 0.9)',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              borderRadius: '8px',
                              zIndex: 10
                            }}>
                              <div style={{
                                textAlign: 'center',
                                padding: '20px',
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                borderRadius: '12px',
                                color: 'white',
                                boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
                              }}>
                                <div style={{ fontSize: '24px', marginBottom: '8px' }}>🔒</div>
                                <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '4px' }}>
                                  Feature Not Available
                                </div>
                                <div style={{ fontSize: '12px', opacity: 0.9 }}>
                                  Upgrade your package to view Team Summary
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        
                        {/* Auction Banner */}
                        {this.state.main_auction_details.auction_banner_img_video && (
                          <div style={{ 
                            width: '100%', 
                            marginTop: '10px',
                            borderRadius: '8px',
                            overflow: 'hidden',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            backgroundColor: '#000'
                          }}>
                            {(() => {
                              const bannerUrl = this.state.main_auction_details.auction_banner_img_video;
                              const extension = bannerUrl.split('.').pop().toLowerCase();
                              const videoFormats = ['mp4', 'webm', 'avi', 'mov'];
                              
                              if (videoFormats.includes(extension)) {
                                return (
                                  <video 
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                    controls 
                                    style={{ 
                                      width: '100%', 
                                      height: '120px',
                                      objectFit: 'cover',
                                      display: 'block'
                                    }}
                                    key={bannerUrl}
                                  >
                                    <source src={bannerUrl} type={`video/${extension === 'mov' ? 'quicktime' : extension}`} />
                                  </video>
                                );
                              } else {
                                return (
                                  <img 
                                    src={bannerUrl} 
                                    alt="Auction Banner" 
                                    style={{
                                      width: '100%',
                                      height: '120px',
                                      objectFit: 'cover',
                                      display: 'block'
                                    }}
                                  />
                                );
                              }
                            })()}
                          </div>
                        )}
                      </td>
                      <td width="5%" valign="top" style={{ marginRight: '5px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
                          {/* Total Players */}
                          <div style={{
                            background: '#e3f2fd',
                            borderRadius: 12,
                            padding: '12px 8px',
                            minWidth: 48,
                            marginBottom: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                          }}>
                            <span style={{ color: '#1976d2', fontSize: 28 }}><i className="material-icons">group</i></span>
                            <span style={{ fontSize: 22, color: '#1a237e', fontWeight: 500 }}>{this.state.main_auction_details.count_players_in_auction}</span>
                          </div>
                          {/* Sold */}
                          <div style={{
                            background: '#e8f5e9',
                            borderRadius: 12,
                            padding: '12px 8px',
                            minWidth: 48,
                            marginBottom: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                          }}>
                            <span style={{ color: '#43a047', fontSize: 28 }}><i className="material-icons">check_circle</i></span>
                            <span style={{ fontSize: 22, color: '#1b5e20', fontWeight: 500 }}>{this.state.main_auction_details.sold_count}</span>
                          </div>
                          {/* Unsold */}
                          <div style={{
                            background: '#ffebee',
                            borderRadius: 12,
                            padding: '12px 8px',
                            minWidth: 48,
                            marginBottom: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                          }}>
                            <span style={{ color: '#e53935', fontSize: 28 }}><i className="material-icons">cancel</i></span>
                            <span style={{ fontSize: 22, color: '#b71c1c', fontWeight: 500 }}>{this.state.main_auction_details.unsold_count}</span>
                          </div>
                          {/* Pending */}
                          <div style={{
                            background: '#fffde7',
                            borderRadius: 12,
                            padding: '12px 8px',
                            minWidth: 48,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                          }}>
                            <span style={{ color: '#fbc02d', fontSize: 28 }}><i className="material-icons">hourglass_empty</i></span>
                            <span style={{ fontSize: 22, color: '#f57c00', fontWeight: 500 }}>{this.state.main_auction_details.pending_count}</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                );
              } else {
                // 3 Column Layout (New)
                const td_title  = this.state.selected_player + '|' + this.state.selected_sl;
                return (
                  <table cellspacing="0" width="100%" cellpadding="0" >
                    <tr>
                      <td width="33%" valign="top" title={td_title} >
                        {/* Enhanced Professional Player Profile Card */}
                        <div style={{ 
                          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          borderRadius: '20px',
                          padding: '10px',
                          boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                          border: '1px solid rgba(255,255,255,0.2)',
                          backdropFilter: 'blur(10px)',
                          position: 'relative',
                          overflow: 'hidden'
                        }}>
                          {/* Decorative Background Elements */}
                          <div style={{
                            position: 'absolute',
                            top: '-50px',
                            right: '-50px',
                            width: '50px',
                            height: '50px',
                            background: 'rgba(255,255,255,0.1)',
                            borderRadius: '50%',
                            zIndex: 1
                          }}></div>
                          <div style={{
                            position: 'absolute',
                            bottom: '-30px',
                            left: '-30px',
                            width: '20px',
                            height: '20px',
                            background: 'rgba(255,255,255,0.05)',
                            borderRadius: '50%',
                            zIndex: 1
                          }}></div>
                          
                          {/* Player Info Header - SL Number and Name on same line */}
                          {
            (() => {
              if (this.state.main_auction_details.show_img_only_in_auction == '0') {
                return (
                  <div style={{ 
                    position: 'relative',
                    zIndex: 2,
                    textAlign: 'center',
                    marginBottom: '15px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '15px',
                    flexWrap: 'wrap'
                  }}>
                    {/* Player SL Number Badge */}
                    <div>
                      {
                        (() => {
                          var blank_page= global.config.app.backend_api_url + 'playerview?img='+this.state.selected_player_pic+'&sl='+this.state.selected_sl+'&name='+this.state.selected_player+'&cric='+this.state.selected_cric_img;
                          return (
                            <a target="_blank" href={blank_page} style={{textDecoration: 'none'}}>
                              <div style={{
                                background: 'linear-gradient(45deg, #ff6b6b, #ee5a24)',
                                color: 'white',
                                fontSize: '20px',
                                fontWeight: 'bold',
                                padding: '8px 16px',
                                borderRadius: '25px',
                                display: 'inline-block',
                                boxShadow: '0 8px 20px rgba(255,107,107,0.4)',
                                border: '2px solid rgba(255,255,255,0.3)',
                                textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer'
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.transform = 'scale(1.05)';
                                e.target.style.boxShadow = '0 12px 25px rgba(255,107,107,0.6)';
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.transform = 'scale(1)';
                                e.target.style.boxShadow = '0 8px 20px rgba(255,107,107,0.4)';
                              }}>
                                {this.state.selected_sl}
                              </div>
                            </a>
                          )
                        })()
                      }
                    </div>

                    {/* Player Name */}
                    <div style={{
                      background: 'rgba(255,255,255,0.95)',
                      color: '#2c3e50',
                      fontSize: '20px',
                      fontWeight: 'bold',
                      padding: '8px 16px',
                      borderRadius: '15px',
                      boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
                      border: '2px solid rgba(255,255,255,0.3)',
                      textTransform: 'uppercase',
                      letterSpacing: '1px',
                      textShadow: '1px 1px 2px rgba(0,0,0,0.1)',
                      display: 'inline-block'
                    }}>
                      {this.state.selected_player}
                    </div>
                  </div>
                )
              }
            })()
          }

                          {/* Player Image Container */}
                          
                          
                          <div style={{ 
                            position: 'relative',
                            zIndex: 2,
                            marginBottom: '10px',
                            display: 'flex',
                            justifyContent: 'center'
                          }}>
                            <div style={{
                              background: 'rgba(255,255,255,0.95)',
                              borderRadius: '15px',
                              padding: '5px',
                              boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
                              border: '3px solid rgba(255,255,255,0.3)'
                            }}>
                              {
                                (() => {

                                  if (this.state.main_auction_details.show_img_only_in_auction == '0') {
                                    const props = {width: '300', zoomPosition:'original', zoomWidth: '300', img: this.state.selected_player_pic ? (this.state.selected_player_pic):(team_player_2)};
                                    return (
                                      <div className="image-zoom-container">
                                    <ReactImageZoom {...props} />
                                  </div>
                                    )
                                  }
                                  else{
                                    const props = {width: '400', height: 520, zoomPosition:'original', zoomWidth: '400', img: this.state.selected_player_pic ? (this.state.selected_player_pic):(team_player_2)};
                                  
                                    return (
                                      <div className="image-zoom-container-big">
                                      <ReactImageZoom {...props} />
                                    </div>
                                    )

                                  }
                                })()
                              }
                            </div>
                          </div>
                </div>
                      </td>
                      <td width="62%" valign="top" className="team-summary-table" id="right_team_table" style={{paddingLeft:'5px'}} >
                        <div style={{ position: 'relative' }}>
                          <div className="team-summary-header">
                            <span style={{ fontSize: '14px', marginRight: '10px' }}>🏏</span>
                            <span>Team Summary</span>
                          </div>
                          <div style={{ 
                            filter: this.state.main_auction_details.hide_team_summary_info === "1" ? 'blur(3px)' : 'none',
                            transition: 'filter 0.3s ease'
                          }}>
                            <div style={{ display: 'flex', gap: '10px' }}>
                          {/* Left Column */}
                          <div style={{ flex: 1 }}>
                            <table className="team-table-2col" style={{ fontSize: "16px", border: "1px solid #ddd", width: '100%' }}>
                              <thead>
                                <tr>
                                  <th style={{ width: '50%', textAlign: 'left', padding: '8px' }}>Team Name</th>
                                  <th style={{ width: '25%', textAlign: 'center', padding: '8px' }}>Max Bid</th>
                                  <th style={{ width: '25%', textAlign: 'center', padding: '8px' }}>Count</th>
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  (() => {
                                    const listitems = this.state.teams_only;
                                    const from_db_current_bid_amount = this.state.sel_current_bid_amount;

                                    if (typeof (listitems) != "undefined") {
                                      const midPoint = Math.ceil(listitems.length / 2);
                                      return listitems.slice(0, midPoint).map((team, i) => {
                                        const teamlist_completed = team.current_players_count === team.team_max_playes_count ? 'teamlist_completed' : '';
                                        const teamlist_disabled = parseInt(from_db_current_bid_amount) >= parseInt(team.max_bid_for_a_player) ? 'disabled_team' : '';
                                        
                                        return (
                                          <tr className="team-row" key={i}>
                                            <td className={`team-name-cell teamlist_right ${teamlist_completed} ${teamlist_disabled}`} style={{ textAlign: 'left', padding: '8px' }}>
                                              <b>{team.team_name.length > 17 ? team.team_name.slice(0, 15) + '..' : team.team_name}</b>
                                            </td>
                                            <td className={`max-bid-cell teamlist_right teamlist_amount ${teamlist_completed} ${teamlist_disabled}`} style={{ textAlign: 'center', padding: '8px' }}>
                                              <b>{team.max_bid_for_a_player}</b>
                                            </td>
                                            <td className={`teamlist_right ${teamlist_completed} ${teamlist_disabled}`} style={{ textAlign: 'center', padding: '8px' }}>
                                              <b>{team.current_players_count}/{team.team_max_playes_count}</b>
                                            </td>
                                          </tr>
                                        );
                                      });
                                    }
                                  })()
                                }
                              </tbody>
                            </table>
                          </div>
                          {/* Right Column */}
                          <div style={{ flex: 1 }}>
                            <table className="team-table-2col" style={{ fontSize: "16px", border: "1px solid #ddd", width: '100%' }}>
                              <thead>
                                <tr>
                                  <th style={{ width: '50%', textAlign: 'left', padding: '8px' }}>Team Name</th>
                                  <th style={{ width: '25%', textAlign: 'center', padding: '8px' }}>Max Bid</th>
                                  <th style={{ width: '25%', textAlign: 'center', padding: '8px' }}>Count</th>
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  (() => {
                                    const listitems = this.state.teams_only;
                                    const from_db_current_bid_amount = this.state.sel_current_bid_amount;

                                    if (typeof (listitems) != "undefined") {
                                      const midPoint = Math.ceil(listitems.length / 2);
                                      return listitems.slice(midPoint).map((team, i) => {
                                        const teamlist_completed = team.current_players_count === team.team_max_playes_count ? 'teamlist_completed' : '';
                                        const teamlist_disabled = parseInt(from_db_current_bid_amount) >= parseInt(team.max_bid_for_a_player) ? 'disabled_team' : '';
                                        
                                        return (
                                          <tr className="team-row" key={i + midPoint}>
                                            <td className={`team-name-cell teamlist_right ${teamlist_completed} ${teamlist_disabled}`} style={{ textAlign: 'left', padding: '8px' }}>
                                             <b>{team.team_name.length > 17 ? team.team_name.slice(0, 15) + '..' : team.team_name}</b>
                                            </td>
                                            <td className={`max-bid-cell teamlist_right teamlist_amount ${teamlist_completed} ${teamlist_disabled}`} style={{ textAlign: 'center', padding: '8px' }}>
                                              <b>{team.max_bid_for_a_player}</b>
                                            </td>
                                            <td className={`teamlist_right ${teamlist_completed} ${teamlist_disabled}`} style={{ textAlign: 'center', padding: '8px' }}>
                                              <b>{team.current_players_count}/{team.team_max_playes_count}</b>
                                            </td>
                                          </tr>
                                        );
                                      });
                                    }
                                  })()
                                }
                              </tbody>
                            </table>
                          </div>
                            </div>
                          </div>
                          
                          {/* Player Stats Container - Multi-stat per row Layout */}
                          <div style={{ 
                            marginTop: '8px',
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '4px'
                          }}>
                            {this.state.selected_role && this.state.selected_role !== '' && this.state.selected_role != null && (
                              <div style={{
                                background: 'rgba(255,255,255,0.95)',
                                color: '#2c3e50',
                                padding: '4px 10px',
                                borderRadius: '5px',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                                border: '1px solid rgba(0,0,0,0.08)',
                                flex: '0 0 auto',
                                whiteSpace: 'nowrap'
                              }}>
                                Role: {this.state.selected_role}
                              </div>
                            )}
                            
                            {this.state.selected_cric_batting_style && this.state.selected_cric_batting_style !== '' && this.state.selected_cric_batting_style != null && (
                              <div style={{
                                background: 'rgba(200,230,201,0.95)',
                                color: '#4caf50',
                                padding: '4px 10px',
                                borderRadius: '5px',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                                border: '1px solid rgba(76,175,80,0.3)',
                                flex: '0 0 auto',
                                whiteSpace: 'nowrap'
                              }}>
                                {this.state.selected_cric_batting_style}
                              </div>
                            )}
                            
                            {this.state.selected_cric_bowling_style && this.state.selected_cric_bowling_style !== '' && this.state.selected_cric_bowling_style != null && (
                              <div style={{
                                background: 'rgba(227,242,253,0.95)',
                                color: '#1976d2',
                                padding: '4px 10px',
                                borderRadius: '5px',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                                border: '1px solid rgba(25,118,210,0.3)',
                                flex: '0 0 auto',
                                whiteSpace: 'nowrap'
                              }}>
                                {this.state.selected_cric_bowling_style}
                              </div>
                            )}
                            
                            {this.state.selected_keeping && this.state.selected_keeping !== '' && this.state.selected_keeping != null && (
                              <div style={{
                                background: 'rgba(255,235,238,0.95)',
                                color: '#c62828',
                                padding: '4px 10px',
                                borderRadius: '5px',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                                border: '1px solid rgba(198,40,40,0.3)',
                                flex: '0 0 auto',
                                whiteSpace: 'nowrap'
                              }}>
                                Keeping: {this.state.selected_keeping}
                              </div>
                            )}
                            
                            {this.state.selected_cric_matches && this.state.selected_cric_matches !== '' && this.state.selected_cric_matches != null && (
                              <div style={{
                                background: 'rgba(255,243,224,0.95)',
                                color: '#e64a19',
                                padding: '4px 10px',
                                borderRadius: '5px',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                                border: '1px solid rgba(230,74,25,0.3)',
                                flex: '0 0 auto',
                                whiteSpace: 'nowrap'
                              }}>
                                Matches: {this.state.selected_cric_matches}
                              </div>
                            )}
                            
                            {this.state.selected_cric_runs && this.state.selected_cric_runs !== '' && this.state.selected_cric_runs != null && (
                              <div style={{
                                background: 'rgba(255,224,178,0.95)',
                                color: '#f4511e',
                                padding: '4px 10px',
                                borderRadius: '5px',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                                border: '1px solid rgba(244,81,30,0.3)',
                                flex: '0 0 auto',
                                whiteSpace: 'nowrap'
                              }}>
                                Runs: {this.state.selected_cric_runs}
                              </div>
                            )}
                            
                            {this.state.selected_cric_wickets && this.state.selected_cric_wickets !== '' && this.state.selected_cric_wickets != null && (
                              <div style={{
                                background: 'rgba(243,229,245,0.95)',
                                color: '#8e24aa',
                                padding: '4px 10px',
                                borderRadius: '5px',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                                border: '1px solid rgba(142,36,170,0.3)',
                                flex: '0 0 auto',
                                whiteSpace: 'nowrap'
                              }}>
                                Wickets: {this.state.selected_cric_wickets}
                              </div>
                            )}
                            
                            {this.state.selected_district_name && this.state.selected_district_name !== '' && this.state.selected_district_name != null && (
                              <div style={{
                                background: 'rgba(225,245,254,0.95)',
                                color: '#0277bd',
                                padding: '4px 10px',
                                borderRadius: '5px',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                                border: '1px solid rgba(2,119,189,0.3)',
                                flex: '0 0 auto',
                                whiteSpace: 'nowrap'
                              }}>
                                District: {this.state.selected_district_name}
                              </div>
                            )}
                            
                            {this.state.selected_previous_team_details && this.state.selected_previous_team_details !== '' && this.state.selected_previous_team_details != null && (
                              <div style={{
                                background: 'rgba(255,249,196,0.95)',
                                color: '#f57c00',
                                padding: '4px 10px',
                                borderRadius: '5px',
                                fontSize: '11px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                                border: '1px solid rgba(245,124,0,0.3)',
                                flex: '0 0 auto',
                                whiteSpace: 'nowrap'
                              }}>
                                Current Club: {this.state.selected_previous_team_details}
                              </div>
                            )}
                          </div>
                          
                          {/* Upgrade Message Overlay */}
                          {this.state.main_auction_details.hide_team_summary_info === "1" && (
                            <div style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              background: 'rgba(255, 255, 255, 0.9)',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              borderRadius: '8px',
                              zIndex: 10
                            }}>
                              <div style={{
                                textAlign: 'center',
                                padding: '20px',
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                borderRadius: '12px',
                                color: 'white',
                                boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
                              }}>
                                <div style={{ fontSize: '24px', marginBottom: '8px' }}>🔒</div>
                                <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '4px' }}>
                                  Feature Not Available
                                </div>
                                <div style={{ fontSize: '12px', opacity: 0.9 }}>
                                  Upgrade your package to view Team Summary
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        
                        {/* Auction Banner */}
                        {this.state.main_auction_details.auction_banner_img_video && (
                          <div style={{ 
                            width: '100%', 
                            marginTop: '10px',
                            borderRadius: '8px',
                            overflow: 'hidden',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            backgroundColor: '#000'
                          }}>
                            {(() => {
                              const bannerUrl = this.state.main_auction_details.auction_banner_img_video;
                              const extension = bannerUrl.split('.').pop().toLowerCase();
                              const videoFormats = ['mp4', 'webm', 'avi', 'mov'];
                              
                              if (videoFormats.includes(extension)) {
                                return (
                                  <video 
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                    controls 
                                    style={{ 
                                      width: '100%', 
                                      height: '120px',
                                      objectFit: 'cover',
                                      display: 'block'
                                    }}
                                    key={bannerUrl}
                                  >
                                    <source src={bannerUrl} type={`video/${extension === 'mov' ? 'quicktime' : extension}`} />
                                  </video>
                                );
                              } else {
                                return (
                                  <img 
                                    src={bannerUrl} 
                                    alt="Auction Banner" 
                                    style={{
                                      width: '100%',
                                      height: '120px',
                                      objectFit: 'cover',
                                      display: 'block'
                                    }}
                                  />
                                );
                              }
                            })()}
                          </div>
                        )}
                      </td>
                      <td width="5%" valign="top" style={{ marginRight: '5px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
                          {/* Total Players */}
                          <div style={{
                            background: '#e3f2fd',
                            borderRadius: 12,
                            padding: '12px 8px',
                            minWidth: 48,
                            marginBottom: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                          }}>
                            <span style={{ color: '#1976d2', fontSize: 28 }}><i className="material-icons">group</i></span>
                            <span style={{ fontSize: 22, color: '#1a237e', fontWeight: 500 }}>{this.state.main_auction_details.count_players_in_auction}</span>
                          </div>
                          {/* Sold */}
                          <div style={{
                            background: '#e8f5e9',
                            borderRadius: 12,
                            padding: '12px 8px',
                            minWidth: 48,
                            marginBottom: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                          }}>
                            <span style={{ color: '#43a047', fontSize: 28 }}><i className="material-icons">check_circle</i></span>
                            <span style={{ fontSize: 22, color: '#1b5e20', fontWeight: 500 }}>{this.state.main_auction_details.sold_count}</span>
                          </div>
                          {/* Unsold */}
                          <div style={{
                            background: '#ffebee',
                            borderRadius: 12,
                            padding: '12px 8px',
                            minWidth: 48,
                            marginBottom: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                          }}>
                            <span style={{ color: '#e53935', fontSize: 28 }}><i className="material-icons">cancel</i></span>
                            <span style={{ fontSize: 22, color: '#b71c1c', fontWeight: 500 }}>{this.state.main_auction_details.unsold_count}</span>
                          </div>
                          {/* Pending */}
                          <div style={{
                            background: '#fffde7',
                            borderRadius: 12,
                            padding: '12px 8px',
                            minWidth: 48,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                          }}>
                            <span style={{ color: '#fbc02d', fontSize: 28 }}><i className="material-icons">hourglass_empty</i></span>
                            <span style={{ fontSize: 22, color: '#f57c00', fontWeight: 500 }}>{this.state.main_auction_details.pending_count}</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                );
              }
            })()
          }
</div>
            {
              (() => {
                const props = {width: 300, zoomPosition:'original',   zoomWidth: '300', img: this.state.selected_player_pic ? (this.state.selected_player_pic):(team_player_2)};
                var blank_page= global.config.app.backend_api_url + 'playerview?img='+this.state.selected_player_pic+'&sl='+this.state.selected_sl+'&name='+this.state.selected_player+'&cric='+this.state.selected_cric_img;
                
                return (
                  <AuctionModalWrapper  >
                    
                    <table style={{ width: '100%' }}>
                      <tbody>
                        <tr>
                          
                          <td style={{ width: '40%' }}>
                    {
                      /*
      <SoftInput placeholder="Sell Amount" autocomplete="off" name="a_sold_amount" id="a_sold_amount" inputProps={{ maxLength: 8 }} />

                      */
                    }
                      
                            <Autocomplete
         name="a_sold_amount" id="a_sold_amount"  inputProps={{ maxLength: 8 }}
        freeSolo
        ListboxProps={{
          style: {
            maxHeight: '100px', // Limit the list height
            overflow: 'auto',   // Enable scrolling for overflow
          },
        }}
        onChange={this.handleChange}
        onHighlightChange={this.handleHighlightChange}
        options={this.state.items.map((option) => option)}
        renderInput={(params) => <TextField {...params}  label="Sell Amount" />}
      />

                            {
                              /*
                            <AutoComplete dropdownAutoFocus="true" dropdownMode="current" placeholder="Sell Amount" dropdown="true" panelStyle={panelStyle} panelClassName="p-autocomplete-panel" value={this.state.value} suggestions={this.state.items} minLength="0" completeMethod={this.search} className="MuiInputBase-input" inputClassName="col-lg-12" onChange={(e) => this.setState({value:e.value})}  />

                              */
                            }


                          </td>
                          <td style={{ width: '10%' }}>
                            &nbsp;
                          </td>
                          
                          <td style={{ width: '50%' }}>
                            <div className="custom-select-wrap">
                              <FormSelect style={{ width: '100%' }} className="MuiInputBase-root MuiInputBase-colorPrimary auctionteam" name="a_match_team_id" id="a_match_team_id" onKeyPress={this.auction_sell_enter}>
                                <option value="" >Choose a team</option>

                                {
                                  (() => {
                                    const listitems = this.state.teams_details;
                                    //console.log(listitems);
                                    //console.log("populating")
                                    if (typeof (listitems) != "undefined") {
                                      //console.log(listitems)
                                      const rows = [];
                                      for (let i = 0; i < listitems.length; i++) {
                                        //team_name,  team_logo, current_wallet_balance, current_players_count, players

                                        rows.push(<option value={listitems[i].match_team_id}>{listitems[i].team_name} ({listitems[i].current_players_count}) (Rs:{listitems[i].max_bid_for_a_player})</option>);
                                      }
                                      return rows;
                                      //return <SoftBox component="ul" display="flex" flexDirection="column" p={0} m={0}>{rows}</SoftBox>;
                                    }

                                  })()

                                }
                              </FormSelect>
                            </div>
                          </td>
                          
                        </tr>
                        <tr><td colSpan="3"><Box sx={{mt: 1}}/></td></tr>
                        <tr>
                          <td>
                            <SoftButton variant="gradient" id="unsoldbtn" size="small" color="error" onClick={this.onClickUnSold}>
                              Mark as Unsold
                            </SoftButton>
                            <img src={loader_img} id="loadergif_unsold" style={{display:'none'}} class="zoom2" height="30"/>
                          </td>
                          <td></td>
                          <td>
                          <SoftButton variant="gradient" id="sellplayerbtn" size="small" color="success"
                            onClick={this.onClickSell}>
                            Sell Player
                          </SoftButton>
                          <img src={loader_img} id="loadergif" style={{display:'none'}} class="zoom2" height="30"/>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    
                            <hr></hr>    
                           

                  </AuctionModalWrapper>
                )

              })()
            }
          </div>
          <button variant="button" className='close-btn' onClick={this.closeshowSell}>
                    <CloseIcon />
                  </button>

        </Modal>


        <Modal
          isOpen={this.state.showEditSell}
          onRequestClose={this.closeEditshowSell}
          style={customStyles1}
          shouldCloseOnOverlayClick={false}
          contentLabel="Modal"
        >

          <div id='i_sell_modal_html1'>

            {
              (() => {

                return (
                  <div >
                    <h1 color="danger" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'red', fontSize: 78 }}>
                      {this.state.e_selected_sl}
                    </h1>
                    <h3 color="danger" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 78 }}>
                      {this.state.e_selected_player}
                    </h3>
                    <table style={{ width: '100%' }}>
                      <tbody>
                        <tr>
                          <td style={{ width: '50%' }}>
                            <FormSelect style={{ width: '100%' }} className="MuiInputBase-root MuiInputBase-colorPrimary " name="e_a_match_team_id" id="e_a_match_team_id">
                              <option value="" >Choose a team</option>

                              {
                                (() => {
                                  const listitems = this.state.teams_details;
                                  //console.log(listitems);
                                  //console.log("populating")
                                  if (typeof (listitems) != "undefined") {
                                    //console.log(listitems)
                                    const rows = [];
                                    for (let i = 0; i < listitems.length; i++) {
                                      //team_name,  team_logo, current_wallet_balance, current_players_count, players

                                      rows.push(<option value={listitems[i].match_team_id}>{listitems[i].team_name}</option>);
                                    }
                                    return rows;
                                    //return <SoftBox component="ul" display="flex" flexDirection="column" p={0} m={0}>{rows}</SoftBox>;
                                  }

                                })()

                              }

                            </FormSelect>
                          </td>
                          <td style={{ width: '10%' }}>
                            &nbsp;
                          </td>
                          <td style={{ width: '40%' }}>
                            <SoftInput  placeholder="Sell Amount" name="e_a_sold_amount" id="e_a_sold_amount" inputProps={{ maxLength: 8 }} />
                          </td>
                        </tr>
                        <tr>
                          <td>

                          </td>
                          <td>
                          </td>
                          <SoftButton variant="gradient" id="changeditbtn" size="small" color="success" title="Change it"
                            onClick={this.onClickEditSell}>
                            Change
                          </SoftButton>
                          <img src={loader_img} id="loadergif_change" style={{display:'none'}} class="zoom2" height="30"/>
                          <td>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <table style={{ width: '30%' }}>
                      <tbody>
                        <tr>
                          <td>
                    <SoftInput  placeholder="Enter mobile number" name="e_new_user_mobile_number" id="e_new_user_mobile_number" inputProps={{ maxLength: 10 }} />
                    
                    <SoftButton variant="gradient" id="changeswapplayer" size="small" color="success" title="Change Player"
                            onClick={this.onClickSwapPlayer}>
                            Change to a new player
                          </SoftButton>
                          </td>
                          </tr>


                          <tr>
                          <td>
                          <br>
                    </br>
                    <SoftButton variant="gradient" id="changeswapplayer_rev" size="small" color="error" title="Reverse Player"
                            onClick={this.onClickReverseSoldPlayer}>
                            Reverse
                          </SoftButton>
                          </td>
                          </tr>

                          </tbody>
                          </table>


                  </div>
                )

              })()
            }
          </div>
          <button variant="button" fontWeight="medium" color="info" onClick={this.closeEditshowSell}>close</button>
        </Modal>

        {/* Image Preview Dialog */}
        <Dialog 
          open={this.state.previewImageOpen} 
          onClose={this.handleCloseImagePreview}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle sx={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            borderBottom: '1px solid #e0e0e0'
          }}>
            Profile Picture Preview
            <IconButton onClick={this.handleCloseImagePreview} size="small">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ 
            p: 0, 
            textAlign: 'center', 
            backgroundColor: '#f5f5f5',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '400px'
          }}>
            {this.state.previewImageUrl && (
              <Box
                component="img"
                src={this.state.previewImageUrl}
                alt="Profile Picture"
                sx={{
                  maxWidth: '100%',
                  maxHeight: '80vh',
                  height: 'auto',
                  objectFit: 'contain',
                  display: 'block',
                  borderRadius: 2
                }}
              />
            )}
          </DialogContent>
        </Dialog>
        
      </DashboardLayout>
    );
  }
}
export default AuctionSpinner;

